import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Table, Card, Btn, Modal, Input, Select, Textarea, Badge, RNLLoader, Spinner } from '../components/UI';
import { exportCSV, ADMIN_CARDS } from '../utils';
import * as api from '../api';
import Avatar from '../components/Avatar';
import Pagination from '../components/requisition/Pagination';

// ─── NAV CONFIG ──────────────────────────────────────────────────────────────

const NAV = [
  {
    group: 'OVERVIEW',
    items: [{ id: 'dashboard', label: 'Access Control Dashboard', icon: DashIcon }],
  },
  {
    group: 'USER MANAGEMENT',
    items: [
      { id: 'users', label: 'User Master', icon: UsersIcon },
      { id: 'roles', label: 'Role Master', icon: ShieldIcon },
      { id: 'permissions', label: 'Permission Matrix', icon: GridIcon },
    ],
  },
  {
    group: 'ACCESS SETUP',
    items: [
      { id: 'branches', label: 'Company / Branch / State / Site', icon: GlobeIcon },
      { id: 'approval_limits', label: 'Approval Limit Setup', icon: LimitIcon },
      { id: 'modification_access', label: 'Modification Access Control', icon: LockIcon },
    ],
  },
  {
    group: 'DATA SCOPE ACCESS CONTROL',
    items: [
      { id: 'year_access', label: 'Year Access Control', icon: CalIcon },
    ],
  },
  {
    group: 'WORKFLOWS',
    items: [
      { id: 'access_requests', label: 'Access Request Center', icon: WorkflowIcon },
    ],
  },
  {
    group: 'AUDIT & REPORTS',
    items: [
      { id: 'audit_trail', label: 'Permission Audit Trail', icon: AuditIcon },
      { id: 'access_reports', label: 'Access Report Center', icon: ReportIcon },
    ],
  },
];

// ─── ICONS ───────────────────────────────────────────────────────────────────

function DashIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" />
      <rect x="14" y="14" width="7" height="7" /><rect x="3" y="14" width="7" height="7" />
    </svg>
  );
}
function UsersIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  );
}
function ShieldIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2 4 6v6c0 5 3.4 8.4 8 10 4.6-1.6 8-5 8-10V6Z" />
    </svg>
  );
}
function GridIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="18" height="18" rx="2" /><line x1="3" y1="9" x2="21" y2="9" />
      <line x1="3" y1="15" x2="21" y2="15" /><line x1="9" y1="3" x2="9" y2="21" /><line x1="15" y1="3" x2="15" y2="21" />
    </svg>
  );
}
function GlobeIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" /><line x1="2" y1="12" x2="22" y2="12" />
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
    </svg>
  );
}
function LimitIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="4" y1="21" x2="4" y2="14" /><line x1="4" y1="10" x2="4" y2="3" />
      <line x1="12" y1="21" x2="12" y2="12" /><line x1="12" y1="8" x2="12" y2="3" />
      <line x1="20" y1="21" x2="20" y2="16" /><line x1="20" y1="12" x2="20" y2="3" />
      <line x1="1" y1="14" x2="7" y2="14" /><line x1="9" y1="8" x2="15" y2="8" /><line x1="17" y1="16" x2="23" y2="16" />
    </svg>
  );
}
function LockIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
  );
}
function CalIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  );
}
function WorkflowIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="7" width="6" height="6" rx="1" /><rect x="16" y="7" width="6" height="6" rx="1" />
      <rect x="9" y="14" width="6" height="6" rx="1" />
      <path d="M5 13v2a2 2 0 0 0 2 2h2" /><path d="M19 13v2a2 2 0 0 1-2 2h-2" />
    </svg>
  );
}
function AuditIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" />
      <line x1="16" y1="13" x2="8" y2="13" /><line x1="16" y1="17" x2="8" y2="17" /><polyline points="10 9 9 9 8 9" />
    </svg>
  );
}
function ReportIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="20" x2="18" y2="10" /><line x1="12" y1="20" x2="12" y2="4" /><line x1="6" y1="20" x2="6" y2="14" />
    </svg>
  );
}

// ─── RISK HELPERS ─────────────────────────────────────────────────────────────

const RISK_COLORS = {
  Low: { bg: '#dcfce7', text: '#15803d', dot: '#22c55e' },
  Medium: { bg: '#fef9c3', text: '#854d0e', dot: '#eab308' },
  High: { bg: '#ffedd5', text: '#9a3412', dot: '#f97316' },
  Critical: { bg: '#fee2e2', text: '#991b1b', dot: '#ef4444' },
};
const RISK_LEVELS = ['Low', 'Medium', 'High', 'Critical'];

function RiskBadge({ level }) {
  const c = RISK_COLORS[level] || RISK_COLORS.Low;
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 4,
      background: c.bg, color: c.text, borderRadius: 999,
      padding: '2px 8px', fontSize: 11, fontWeight: 700,
    }}>
      <span style={{ width: 6, height: 6, borderRadius: 999, background: c.dot, flexShrink: 0 }} />
      {level || 'Low'}
    </span>
  );
}

function StatusBadge({ user }) {
  if (user.is_locked) return <Badge color="red" pulse>Locked</Badge>;
  if (!user.is_active) return <Badge color="gray">Inactive</Badge>;
  if (!user.is_verified) return <Badge color="amber">Pending</Badge>;
  return <Badge color="green">Active</Badge>;
}

// ─── STAT CARD ────────────────────────────────────────────────────────────────

function StatCard({ label, value, sub, color = '#3b82f6', icon }) {
  return (
    <div style={{
      background: color, border: '2px solid #fff',
      borderRadius: 14, padding: '18px 20px', display: 'flex', flexDirection: 'column', gap: 6,
      boxShadow: '0 0 0 2px #000, 0 4px 12px rgba(0,0,0,0.18)',
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <span style={{ fontSize: 11, fontWeight: 700, color: 'rgba(255,255,255,0.85)', textTransform: 'uppercase', letterSpacing: '0.06em' }}>{label}</span>
        {icon && <span style={{ color: 'rgba(255,255,255,0.75)' }}>{icon}</span>}
      </div>
      <span style={{ fontSize: 32, fontWeight: 800, color: '#fff', lineHeight: 1 }}>{value ?? '—'}</span>
      {sub && <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.7)' }}>{sub}</span>}
    </div>
  );
}

// ─── SECTION LOADER ──────────────────────────────────────────────────────────

function SectionLoader() {
  return <RNLLoader title="Loading..." subtitle="Please wait" />;
}

// ─── ACCESS CONTROL DASHBOARD ────────────────────────────────────────────────

function AccessDashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.getUserAccessStats()
      .then(s => setStats(s))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <SectionLoader />;

  const s = stats || {};

  return (
    <div className="fade-in">
      <div style={{ marginBottom: 24 }}>
        <div style={{ fontSize: 18, fontWeight: 800, color: 'var(--text-primary)' }}>Access Control Dashboard</div>
        <div style={{ fontSize: 13, color: 'var(--text-secondary)', marginTop: 4 }}>
          Real-time overview of user access, permissions, risks, and requests
        </div>
      </div>

      {/* Primary metrics */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 14, marginBottom: 24 }}>
        <StatCard label="Total Users" value={s.total_users ?? 0} icon={<UsersIcon />} color="#3b82f6" />
        <StatCard label="Active Users" value={s.active_users ?? 0} icon={<UsersIcon />} color="#16a34a" />
        <StatCard label="Locked / Suspended" value={s.locked_users ?? 0} color="#dc2626" icon={<LockIcon />} />
        <StatCard label="MFA Enabled" value={s.mfa_enabled ?? 0} color="#7c3aed" icon={<ShieldIcon />} />
        <StatCard label="Critical Risk Users" value={s.critical_risk_users ?? 0} color="#ef4444" icon={<ShieldIcon />} sub="Needs review" />
        <StatCard label="High Risk Users" value={s.high_risk_users ?? 0} color="#f97316" icon={<ShieldIcon />} />
        <StatCard label="Inactive / Dormant" value={s.inactive_users ?? 0} color="#64748b" />
      </div>

      {/* Charts area */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 24 }}>
        {/* Users by Role */}
        <div style={{
          background: 'var(--bg-surface)', border: '1px solid #000',
          borderRadius: 14, padding: '20px 22px',
        }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--text-primary)', marginBottom: 16 }}>Users by Role</div>
          {(s.users_by_role || []).length === 0 ? (
            <div style={{ fontSize: 12, color: 'var(--text-muted)', textAlign: 'center', padding: 24 }}>No data yet</div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {(s.users_by_role || []).slice(0, 8).map((r, i) => {
                const max = Math.max(...(s.users_by_role || []).map(x => x.count), 1);
                const pct = Math.round((r.count / max) * 100);
                return (
                  <div key={i}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                      <span style={{ fontSize: 12, color: 'var(--text-primary)', fontWeight: 600 }}>{r.role}</span>
                      <span style={{ fontSize: 12, color: 'var(--text-secondary)', fontWeight: 700 }}>{r.count}</span>
                    </div>
                    <div style={{ height: 6, background: 'var(--bg-elevated)', borderRadius: 999 }}>
                      <div style={{ height: '100%', width: `${pct}%`, background: 'var(--accent)', borderRadius: 999, transition: 'width 0.5s ease' }} />
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {/* Risk distribution */}
        <div style={{
          background: 'var(--bg-surface)', border: '1px solid #000',
          borderRadius: 14, padding: '20px 22px',
        }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--text-primary)', marginBottom: 16 }}>Risk Level Distribution</div>
          {(s.risk_distribution || []).length === 0 ? (
            <div style={{ fontSize: 12, color: 'var(--text-muted)', textAlign: 'center', padding: 24 }}>No data yet</div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              {RISK_LEVELS.map(level => {
                const row = (s.risk_distribution || []).find(r => r.level === level);
                const count = row?.count || 0;
                const total = s.total_users || 1;
                const pct = Math.round((count / total) * 100);
                const c = RISK_COLORS[level];
                return (
                  <div key={level} style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <span style={{ width: 56, fontSize: 11.5, fontWeight: 700, color: c.text }}>{level}</span>
                    <div style={{ flex: 1, height: 8, background: 'var(--bg-elevated)', borderRadius: 999 }}>
                      <div style={{ height: '100%', width: `${pct}%`, background: c.dot, borderRadius: 999, transition: 'width 0.5s ease' }} />
                    </div>
                    <span style={{ width: 28, fontSize: 12, fontWeight: 700, color: 'var(--text-secondary)', textAlign: 'right' }}>{count}</span>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>

      {/* Quick user table */}
      <div style={{
        background: 'var(--bg-surface)', border: '1px solid #000',
        borderRadius: 14, padding: '20px 22px',
      }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--text-primary)', marginBottom: 4 }}>All Users — Quick View</div>
        <div style={{ fontSize: 12, color: 'var(--text-secondary)', marginBottom: 16 }}>Overview of all system users and their access status</div>
        <QuickUserTable />
      </div>
    </div>
  );
}

// ─── QUICK USER TABLE (used in Dashboard) ────────────────────────────────────

function QuickUserTable() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    api.listUsers(0, 50)
      .then(u => setUsers(Array.isArray(u) ? u : []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const q = search.trim().toLowerCase();
  const visible = users.filter(u => !q || [
    u.first_name, u.last_name, u.email, u.employee_id, u.job_title, u.branch,
  ].some(v => (v || '').toLowerCase().includes(q)));

  return (
    <>
      <div style={{ marginBottom: 12 }}>
        <input
          value={search} onChange={e => setSearch(e.target.value)}
          placeholder="Search users…"
          style={{
            width: '100%', maxWidth: 340, boxSizing: 'border-box',
            padding: '8px 12px', border: '1.5px solid var(--border-strong)',
            borderRadius: 8, fontSize: 13, fontFamily: 'var(--font)',
            background: 'var(--bg-surface)', color: 'var(--text-primary)',
          }}
        />
      </div>
      <div style={{ overflowX: 'auto' }}>
        {(() => {
          const thS = { padding: '11px 14px', fontWeight: 700, fontSize: 12, color: '#fff', textTransform: 'uppercase', letterSpacing: '0.06em', whiteSpace: 'nowrap', textAlign: 'left', border: '1px solid rgba(255,255,255,0.2)', background: '#0b318bff' };
          const tdS = { padding: '10px 14px', fontSize: 12.5, border: '1px solid #e2e8f0', verticalAlign: 'middle' };
          return (
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#0b318bff', color: '#fff' }}>
              {['Full Name', 'Email', 'Emp ID', 'Role', 'Branch', 'Status', 'Risk', 'MFA'].map(h => (
                <th key={h} style={thS}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={8}><SectionLoader /></td></tr>
            ) : visible.length === 0 ? (
              <tr><td colSpan={8} style={{ textAlign: 'center', padding: 24, color: 'var(--text-muted)' }}>No users found</td></tr>
            ) : visible.slice(0, 20).map((u, ri) => (
              <tr key={u.user_id}
                style={{ background: ri % 2 === 0 ? '#fff' : '#f8fafc' }}
                onMouseEnter={e => e.currentTarget.style.background = '#eff6ff'}
                onMouseLeave={e => e.currentTarget.style.background = ri % 2 === 0 ? '#fff' : '#f8fafc'}>
                <td style={tdS}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <Avatar first={u.first_name} last={u.last_name} src={u.profile_pic} size={26} />
                    <span style={{ fontWeight: 700, whiteSpace: 'nowrap', color: '#0f172a' }}>{u.first_name} {u.last_name}</span>
                  </div>
                </td>
                <td style={{ ...tdS, fontFamily: 'var(--mono)', fontSize: 11.5, color: '#475569' }}>{u.email}</td>
                <td style={{ ...tdS, color: '#64748b' }}>{u.employee_id || '—'}</td>
                <td style={tdS}>
                  {(u.roles || []).map(r => (
                    <span key={r.role_id} style={{ fontSize: 11, background: 'var(--accent-dim)', color: 'var(--accent)', borderRadius: 999, padding: '2px 7px', marginRight: 4, fontWeight: 700 }}>
                      {r.display_name}
                    </span>
                  ))}
                </td>
                <td style={{ ...tdS, color: '#64748b' }}>{u.branch || '—'}</td>
                <td style={tdS}><StatusBadge user={u} /></td>
                <td style={tdS}><RiskBadge level={u.risk_level} /></td>
                <td style={tdS}>
                  {u.mfa_enabled
                    ? <Badge color="green">On</Badge>
                    : <Badge color="gray">Off</Badge>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
          );
        })()}
        {visible.length > 20 && (
          <div style={{ fontSize: 12, color: 'var(--text-muted)', textAlign: 'center', padding: '12px 0' }}>
            Showing 20 of {visible.length}. Go to User Master for the full list.
          </div>
        )}
      </div>
    </>
  );
}

// ─── USER MASTER ─────────────────────────────────────────────────────────────

function UserMaster({ toast }) {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [committed, setCommitted] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [riskFilter, setRiskFilter] = useState('all');
  const [page, setPage] = useState({ skip: 0, limit: 25 });
  const [total, setTotal] = useState(0);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const u = await api.listUsers(page.skip, page.limit, committed);
      setUsers(Array.isArray(u) ? u : []);
      if (u.totalCount != null) setTotal(u.totalCount);
    } catch { }
    setLoading(false);
  }, [page, committed]);

  useEffect(() => { load(); }, [load]);

  const handleSearch = () => {
    setCommitted(search.trim());
    setPage(p => ({ ...p, skip: 0 }));
  };

  // Status/risk filters remain client-side (no extra round-trip needed for
  // these small filter dimensions on an already-paged result set)
  const visible = users.filter(u => {
    if (statusFilter === 'active' && (!u.is_active || u.is_locked)) return false;
    if (statusFilter === 'inactive' && u.is_active) return false;
    if (statusFilter === 'locked' && !u.is_locked) return false;
    if (statusFilter === 'pending' && u.is_verified) return false;
    if (riskFilter !== 'all' && (u.risk_level || 'Low') !== riskFilter) return false;
    return true;
  });

  return (
    <div className="fade-in">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20, flexWrap: 'wrap', gap: 12 }}>
        <div>
          <div style={{ fontSize: 18, fontWeight: 800, color: 'var(--text-primary)' }}>User Master</div>
          <div style={{ fontSize: 12.5, color: 'var(--text-secondary)', marginTop: 3 }}>{total || users.length} total users</div>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <Btn variant="ghost" onClick={() => exportCSV(visible.map(u => ({
            'Full Name': `${u.first_name} ${u.last_name}`,
            'Email': u.email, 'Employee ID': u.employee_id || '',
            'Role': (u.roles || []).map(r => r.display_name).join(', '),
            'Branch': u.branch || '', 'Status': u.is_locked ? 'Locked' : u.is_active ? 'Active' : 'Inactive',
            'Risk': u.risk_level || 'Low', 'MFA': u.mfa_enabled ? 'Yes' : 'No',
            'Last Login': u.last_login_at || '',
          })), 'user-master')}>Export</Btn>
          <Btn onClick={() => navigate('/admin/users/new')}>+ New User</Btn>
        </div>
      </div>

      {/* Filters */}
      <div style={{ display: 'flex', gap: 10, marginBottom: 16, flexWrap: 'wrap', alignItems: 'center' }}>
        <div style={{ display: 'flex', flex: '1 1 300px', maxWidth: 440, border: '1.5px solid var(--border-strong)', borderRadius: 9, overflow: 'hidden', background: 'var(--bg-surface)' }}>
          <input
            value={search}
            onChange={e => setSearch(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleSearch()}
            placeholder="Search name, email, employee ID…"
            style={{ flex: 1, padding: '8px 12px', border: 'none', outline: 'none', fontSize: 13, fontFamily: 'var(--font)', background: 'transparent', color: 'var(--text-primary)', minWidth: 0 }}
          />
          <button
            onClick={handleSearch}
            style={{ padding: '8px 16px', background: '#0b318bff', border: 'none', cursor: 'pointer', color: '#fff', display: 'flex', alignItems: 'center', gap: 6, fontSize: 12.5, fontWeight: 700, whiteSpace: 'nowrap', flexShrink: 0 }}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><circle cx="11" cy="11" r="7" /><line x1="20" y1="20" x2="16.65" y2="16.65" /></svg>
            Search
          </button>
        </div>
        <select
          value={statusFilter} onChange={e => setStatusFilter(e.target.value)}
          style={{ padding: '8px 12px', border: '1.5px solid var(--border-strong)', borderRadius: 9, fontSize: 13, fontFamily: 'var(--font)', background: 'var(--bg-surface)', color: 'var(--text-primary)', cursor: 'pointer' }}>
          <option value="all">All Status</option>
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
          <option value="locked">Locked</option>
          <option value="pending">Pending Verification</option>
        </select>
        <select
          value={riskFilter} onChange={e => setRiskFilter(e.target.value)}
          style={{ padding: '8px 12px', border: '1.5px solid var(--border-strong)', borderRadius: 9, fontSize: 13, fontFamily: 'var(--font)', background: 'var(--bg-surface)', color: 'var(--text-primary)', cursor: 'pointer' }}>
          <option value="all">All Risk Levels</option>
          {RISK_LEVELS.map(l => <option key={l} value={l}>{l}</option>)}
        </select>
        {(statusFilter !== 'all' || riskFilter !== 'all') && visible.length !== users.length && (
          <span style={{ fontSize: 12.5, color: 'var(--text-secondary)' }}>{visible.length} of {users.length} on this page</span>
        )}
      </div>

      {/* Table */}
      <div style={{ background: 'var(--bg-surface)', border: '1px solid #000', borderRadius: 14, overflow: 'hidden' }}>
        <div style={{ overflowX: 'auto' }}>
          {(() => {
            const thS = { padding: '11px 14px', fontWeight: 700, fontSize: 12, color: '#fff', textTransform: 'uppercase', letterSpacing: '0.06em', whiteSpace: 'nowrap', textAlign: 'left', border: '1px solid rgba(255,255,255,0.2)', background: '#0b318bff' };
            const tdS = { padding: '10px 14px', fontSize: 12.5, border: '1px solid #e2e8f0', verticalAlign: 'middle' };
            return (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#0b318bff', color: '#fff' }}>
                {['User', 'Email', 'Emp ID', 'Dept', 'Role', 'Branch', 'Status', 'Risk', 'MFA', 'Last Login', ''].map(h => (
                  <th key={h} style={thS}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={11}><SectionLoader /></td></tr>
              ) : visible.length === 0 ? (
                <tr><td colSpan={11} style={{ textAlign: 'center', padding: 32, color: 'var(--text-muted)', fontSize: 13 }}>No users found</td></tr>
              ) : visible.map((u, ri) => (
                <tr key={u.user_id}
                  style={{ background: ri % 2 === 0 ? '#fff' : '#f8fafc' }}
                  onMouseEnter={e => e.currentTarget.style.background = '#eff6ff'}
                  onMouseLeave={e => e.currentTarget.style.background = ri % 2 === 0 ? '#fff' : '#f8fafc'}>
                  <td style={tdS}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <Avatar first={u.first_name} last={u.last_name} src={u.profile_pic} size={28} />
                      <div>
                        <div style={{ fontWeight: 700, whiteSpace: 'nowrap', color: '#0f172a' }}>{u.first_name} {u.last_name}</div>
                        {u.job_title && <div style={{ fontSize: 11, color: '#94a3b8' }}>{u.job_title}</div>}
                      </div>
                    </div>
                  </td>
                  <td style={{ ...tdS, fontFamily: 'var(--mono)', fontSize: 11.5, color: '#475569' }}>{u.email}</td>
                  <td style={{ ...tdS, color: '#64748b' }}>{u.employee_id || '—'}</td>
                  <td style={{ ...tdS, color: '#64748b', maxWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {(u.departments || []).map(d => d.name).join(', ') || '—'}
                  </td>
                  <td style={tdS}>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 3 }}>
                      {(u.roles || []).map(r => (
                        <span key={r.role_id} style={{ fontSize: 10.5, background: 'var(--accent-dim)', color: 'var(--accent)', borderRadius: 999, padding: '2px 6px', fontWeight: 700 }}>
                          {r.display_name}
                        </span>
                      ))}
                    </div>
                  </td>
                  <td style={{ ...tdS, color: '#64748b' }}>{u.branch || '—'}</td>
                  <td style={tdS}><StatusBadge user={u} /></td>
                  <td style={tdS}><RiskBadge level={u.risk_level} /></td>
                  <td style={tdS}>
                    {u.mfa_enabled
                      ? <Badge color="green">On</Badge>
                      : <span style={{ color: '#94a3b8', fontSize: 11.5 }}>Off</span>}
                  </td>
                  <td style={{ ...tdS, color: '#94a3b8', fontSize: 11.5, whiteSpace: 'nowrap' }}>
                    {u.last_login_at ? new Date(u.last_login_at).toLocaleDateString() : '—'}
                  </td>
                  <td style={tdS}>
                    <div style={{ display: 'flex', gap: 4 }}>
                      <button title="View profile" onClick={() => navigate(`/admin/users/${u.user_id}`)}
                        style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 4, color: 'var(--accent)', borderRadius: 6 }}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" /></svg>
                      </button>
                      <button title="Edit user" onClick={() => navigate(`/admin/users/${u.user_id}/edit`)}
                        style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 4, color: '#64748b', borderRadius: 6 }}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z" /></svg>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
            );
          })()}
        </div>
        <div style={{ borderTop: '1px solid #e2e8f0' }}>
          <Pagination total={total} skip={page.skip} limit={page.limit} onChange={setPage} />
        </div>
      </div>
    </div>
  );
}

// ─── ROLE MASTER ─────────────────────────────────────────────────────────────

function RoleMaster({ toast }) {
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);
  const [search, setSearch] = useState('');
  const [expandedRole, setExpandedRole] = useState(null);
  const [hoveredRole, setHoveredRole] = useState(null);

  const load = async () => {
    setLoading(true);
    try { const r = await api.listRoles(); setRoles(Array.isArray(r) ? r : []); }
    catch { }
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const q = search.trim().toLowerCase();
  const visible = roles.filter(r => !q || [r.display_name, r.role_name, r.description].some(v => (v || '').toLowerCase().includes(q)));

  const set = k => v => setForm(f => ({ ...f, [k]: v }));

  const save = async () => {
    setSaving(true);
    try {
      const payload = { ...form, name: form.role_name };
      if (modal === 'create') await api.createRole(payload);
      else await api.updateRole(form.role_id, payload);
      toast.show('Role saved'); setModal(null); load();
    } catch (e) { toast.show(e.message, 'error'); }
    setSaving(false);
  };

  return (
    <div className="fade-in">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20, flexWrap: 'wrap', gap: 12 }}>
        <div>
          <div style={{ fontSize: 18, fontWeight: 800, color: 'var(--text-primary)' }}>Role Master</div>
          <div style={{ fontSize: 12.5, color: 'var(--text-secondary)', marginTop: 3 }}>{roles.length} roles configured</div>
        </div>
        <Btn onClick={() => { setForm({}); setModal('create'); }}>+ New Role</Btn>
      </div>

      {/* Search */}
      <div style={{ marginBottom: 16 }}>
        <input
          value={search} onChange={e => setSearch(e.target.value)}
          placeholder="Search by role name or description…"
          style={{ padding: '8px 12px', border: '1.5px solid var(--border-strong)', borderRadius: 9, fontSize: 13, fontFamily: 'var(--font)', background: 'var(--bg-surface)', color: 'var(--text-primary)', width: '100%', maxWidth: 380, boxSizing: 'border-box' }}
        />
      </div>

      {/* Role Cards */}
      {loading ? (
        <SectionLoader />
      ) : visible.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 32, color: 'var(--text-muted)', fontSize: 13 }}>No roles found.</div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 14 }}>
          {visible.map((role, idx) => {
            const CARD_COLORS   = ['#dbeafe','#dcfce7','#fde68a','#ede9fe','#fce7f3','#cffafe','#fed7aa','#d1fae5','#e0e7ff','#fef08a','#fbcfe8','#bfdbfe','#a7f3d0','#fdd0a2','#ddd6fe'];
            const BORDER_COLORS = ['#2563eb','#16a34a','#d97706','#7c3aed','#db2777','#0891b2','#ea580c','#059669','#4338ca','#ca8a04','#be185d','#1d4ed8','#047857','#c2410c','#6d28d9'];
            const base   = CARD_COLORS[idx % CARD_COLORS.length];
            const border = BORDER_COLORS[idx % BORDER_COLORS.length];
            return (
            <div key={role.role_id} className="dk-tint-card"
              onMouseEnter={() => setHoveredRole(role.role_id)}
              onMouseLeave={() => setHoveredRole(null)}
              style={{ '--tint': border, background: base, border: hoveredRole === role.role_id ? `2px solid ${border}` : `1px solid ${border}`, borderRadius: 14, overflow: 'hidden', transition: 'border-width 0.15s' }}>
              {/* Header */}
              <div style={{ padding: '16px 18px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', cursor: 'pointer' }}
                onClick={() => setExpandedRole(expandedRole === role.role_id ? null : role.role_id)}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                    <span style={{ width: 32, height: 32, borderRadius: 999, background: 'var(--accent-dim)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                      <ShieldIcon />
                    </span>
                    <strong className="dk-tint-title" style={{ fontSize: 14, color: 'var(--text-primary)' }}>{role.display_name}</strong>
                  </div>
                  <span style={{ fontSize: 11.5, fontFamily: 'var(--mono)', color: 'var(--accent)', background: 'var(--accent-dim)', borderRadius: 6, padding: '2px 7px' }}>{role.role_name}</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                  <span style={{ fontSize: 11, background: 'var(--bg-elevated)', color: 'var(--text-secondary)', borderRadius: 999, padding: '3px 8px', fontWeight: 600 }}>
                    {role.permissions?.length || 0} permissions
                  </span>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" style={{ transform: expandedRole === role.role_id ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s', color: 'var(--text-muted)' }}><path d="m6 9 6 6 6-6" /></svg>
                </div>
              </div>

              {/* Expanded content */}
              {expandedRole === role.role_id && (
                <div style={{ padding: '0 18px 16px', borderTop: '1px solid var(--border-light)' }}>
                  {role.description && (
                    <p style={{ fontSize: 12.5, color: 'var(--text-secondary)', margin: '12px 0 10px', lineHeight: 1.5 }}>{role.description}</p>
                  )}
                  {(role.permissions || []).length > 0 && (
                    <div style={{ marginBottom: 12 }}>
                      <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 6 }}>Permissions</div>
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                        {role.permissions.map(p => (
                          <span key={p} style={{ fontSize: 10.5, background: 'var(--bg-elevated)', color: 'var(--text-secondary)', borderRadius: 6, padding: '2px 7px', fontFamily: 'var(--mono)' }}>{p}</span>
                        ))}
                      </div>
                    </div>
                  )}
                  <div style={{ display: 'flex', gap: 6, marginTop: 10 }}>
                    <Btn size="sm" onClick={() => { setForm({ ...role }); setModal('edit'); }}>Edit Role</Btn>
                  </div>
                </div>
              )}
            </div>
            );
          })}
        </div>
      )}

      {modal && (
        <Modal title={modal === 'create' ? 'New Role' : 'Edit Role'} onClose={() => setModal(null)}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16, minWidth: 340 }}>
            {modal === 'create' && (
              <Input label="Role Key (no spaces, e.g. quantity_surveyor)" required value={form.role_name || ''} onChange={set('role_name')} placeholder="role_key" />
            )}
            <Input label="Display Name" required value={form.display_name || ''} onChange={set('display_name')} placeholder="e.g. Quantity Surveyor" />
            <Textarea label="Description" value={form.description || ''} onChange={set('description')} rows={2} />
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
              <Btn variant="ghost" onClick={() => setModal(null)}>Cancel</Btn>
              <Btn onClick={save} loading={saving}>Save Role</Btn>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}

// ─── PERMISSION MATRIX ───────────────────────────────────────────────────────

// System Administration cards: admin_<card>:view|add|edit|delete, all enforced (server routes + the
// card's buttons). User Access Control, Roles Control, Workflow Configs and Settings are super-admin only
// and are not listed. Keys mirror backend/app/core/permissions.py → ADMIN_CARDS.
const ADMIN_CARD_LABELS = {
  projects: 'Project Setup', departments: 'Departments', pr_types: 'Purchase Request Types',
  consideration_statuses: 'Consideration Statuses', pr_ledgers: 'Purchase Request Ledger', payment_methods: 'Voucher Creation Methods',
  cost_centres: 'Cost Centre', cost_object_types: 'Cost Object Types', category_asset_types: 'Category / Asset Types',
  cost_objects: 'Cost Objects', disciplines: 'Disciplines', categories: 'Cost Categories', uom: 'Units of Measure',
  materials: 'Materials Master', account_ledgers: 'Account Ledgers', package_types: 'BOQ Package Types',
  budget_control_levels: 'Budget Control Levels', cost_groups: 'Cost Groups', expense_categories: 'Expense Categories',
  expense_sub_categories: 'Expense Sub Categories', dmr_categories: 'DMR Categories', suppliers: 'Suppliers',
};
const ADMIN_CARD_GROUPS = [
  ...ADMIN_CARDS.map(card => ({
    key: `admin_${card}`,
    label: `Admin · ${ADMIN_CARD_LABELS[card] || card}`,
    enforced: true,
    actions: [
      { key: 'view', label: 'View (card and screen)', enforced: true },
      { key: 'add', label: 'Add', enforced: true },
      { key: 'edit', label: 'Edit (incl. reactivate)', enforced: true },
      { key: 'delete', label: 'Delete / deactivate', enforced: true },
    ],
  })),
  {
    // Login as User, permanent delete and granting the super_admin role are super-admin only, and a
    // super-admin account can only be changed by a super admin — so they are not listed here.
    key: 'admin_users',
    label: 'Admin · Users Management',
    enforced: true,
    actions: [
      { key: 'view', label: 'View users and profiles', enforced: true },
      { key: 'create', label: 'Create users', enforced: true },
      { key: 'edit', label: 'Edit details (name, email, phone, job, departments)', enforced: true },
      { key: 'assign_roles', label: 'Assign roles (never super_admin, never own)', enforced: true },
      { key: 'lock', label: 'Lock / unlock accounts', enforced: true },
      { key: 'deactivate', label: 'Deactivate / reactivate', enforced: true },
      { key: 'reset_password', label: 'Reset password', enforced: true },
      { key: 'mfa', label: 'Require / reset two-step sign-in', enforced: true },
    ],
  },
  {
    key: 'admin_request_management',
    label: 'Admin · Request Management',
    enforced: true,
    actions: [
      { key: 'view', label: 'View (card and screen)', enforced: true },
      { key: 'manage', label: 'Permanently delete requisitions / vouchers', enforced: true },
    ],
  },
];

export const MODULE_TAXONOMY = [
  {
    key: 'dashboard',
    label: 'Dashboard & Overview',
    actions: [
      { key: 'view', label: 'View Dashboard (without it: no Dashboard page)', enforced: true },
      { key: 'export', label: 'Export Reports' },
    ],
  },
  {
    key: 'enterprise_requisition',
    label: 'Enterprise Requisition',
    actions: [
      { key: 'view', label: 'Use Enterprise Requisition (without it: no access at all)', enforced: true },
      { key: 'create', label: 'Create Requisition' },
      { key: 'edit', label: 'Edit Own Requisition' },
      { key: 'submit', label: 'Submit for Approval' },
      { key: 'approve', label: 'Approve' },
      { key: 'return', label: 'Return for Revision' },
      { key: 'reject', label: 'Reject' },
      { key: 'recall', label: 'Recall Submitted' },
      { key: 'export', label: 'Export / Print' },
    ],
  },
  {
    key: 'payment_voucher',
    label: 'Payment Voucher',
    actions: [
      { key: 'view', label: 'View Vouchers (opens the module card)', enforced: true },
      { key: 'create', label: 'Create Voucher' },
      { key: 'edit', label: 'Edit Own Voucher' },
      { key: 'submit', label: 'Submit for Approval' },
      { key: 'approve', label: 'Approve' },
      { key: 'return', label: 'Return for Revision' },
      { key: 'reject', label: 'Reject' },
      { key: 'release', label: 'Release to Expense Register' },
      { key: 'export', label: 'Export / Print' },
    ],
  },
  {
    key: 'material_request',
    label: 'Material Request',
    actions: [
      { key: 'view', label: 'Use Material Request (without it: no access at all)', enforced: true },
      { key: 'create', label: 'Create Request' },
      { key: 'edit', label: 'Edit Own Request' },
      { key: 'submit', label: 'Submit for Approval' },
      { key: 'approve', label: 'Approve' },
      { key: 'return', label: 'Return for Revision' },
      { key: 'reject', label: 'Reject' },
      { key: 'export', label: 'Export / Print' },
    ],
  },
  {
    key: 'material_po',
    label: 'Material Purchase Orders',
    actions: [
      { key: 'view', label: 'Use Material PO (without it: no access at all)', enforced: true },
      { key: 'create', label: 'Create PO' },
      { key: 'edit', label: 'Edit Own PO' },
      { key: 'submit', label: 'Submit for Approval' },
      { key: 'approve', label: 'Approve' },
      { key: 'return', label: 'Return for Revision' },
      { key: 'reject', label: 'Reject' },
      { key: 'issue', label: 'Mark as Issued' },
      { key: 'close', label: 'Close PO' },
      { key: 'export', label: 'Export / Print' },
    ],
  },
  {
    key: 'expense_master',
    label: 'Expense Master',
    actions: [
      { key: 'view', label: 'View Expenses (opens the module card)', enforced: true },
      { key: 'create', label: 'Create Entry' },
      { key: 'edit', label: 'Edit Entry' },
      { key: 'delete', label: 'Delete Entry' },
      { key: 'export', label: 'Export' },
    ],
  },
  {
    key: 'boq_hub',
    label: 'BOQ Hub',
    actions: [
      { key: 'view', label: 'View BOQ (opens the BOQ Hub card)', enforced: true },
      { key: 'create', label: 'Create BOQ' },
      { key: 'edit', label: 'Edit BOQ' },
      { key: 'delete', label: 'Delete BOQ' },
      { key: 'export', label: 'Export' },
    ],
  },
  {
    key: 'qs_hub',
    label: 'QS Hub',
    actions: [
      { key: 'view', label: 'View QS Items (opens the QS Hub card)', enforced: true },
      { key: 'create', label: 'Create Entry' },
      { key: 'edit', label: 'Edit Entry' },
      { key: 'delete', label: 'Delete Entry' },
      { key: 'export', label: 'Export' },
    ],
  },
  {
    key: 'reports',
    label: 'Reports & Analytics',
    actions: [
      { key: 'view', label: 'View Reports' },
      { key: 'export', label: 'Export Reports' },
    ],
  },
  {
    key: 'cost_control',
    label: 'Cost Control',
    actions: [
      { key: 'view', label: 'View Cost Control (opens the card and Report Entry)', enforced: true },
    ],
  },
  {
    key: 'hr_people',
    label: 'HR & People',
    actions: [
      { key: 'view', label: 'View HR & People (read-only; editing stays with HR managers)', enforced: true },
    ],
  },
  {
    key: 'hr_requests',
    label: 'HR Request Center',
    actions: [
      { key: 'create', label: 'Create — raise requests and see your own', enforced: true },
      { key: 'view_all', label: 'View All — see every request, its trail and reports', enforced: true },
      { key: 'configure', label: 'Configure — number formats, required fields and SLAs', enforced: true },
    ],
  },
  {
    key: 'adv_requests',
    label: 'HR Request Center — Advanced',
    actions: [
      { key: 'create', label: 'Create — raise Advanced requests and see your own', enforced: true },
      { key: 'view_all', label: 'View All — see every request (not confidential ones)', enforced: true },
      { key: 'view_confidential', label: 'View Confidential — see confidential requests', enforced: true },
      { key: 'assign', label: 'Assign — assign officers, action taken, convert, link to payroll, retire, close', enforced: true },
      { key: 'configure', label: 'Configure — request types, rules, numbering and budgets', enforced: true },
      { key: 'report', label: 'Report — export registers and reports', enforced: true },
    ],
  },
  {
    key: 'hr_expenses',
    label: 'HR Expenses',
    actions: [
      { key: 'create', label: 'Create — record HR expenses and see your own', enforced: true },
      { key: 'view_all', label: 'View All — see every HR expense', enforced: true },
      { key: 'manage', label: "Manage — cancel, archive, restore and delete others' expenses", enforced: true },
      { key: 'budget', label: 'Budget — set department HR expense budgets', enforced: true },
      { key: 'configure', label: 'Configure — expense types and their defaults', enforced: true },
      { key: 'report', label: 'Report — export registers and reports', enforced: true },
    ],
  },
  {
    key: 'payroll',
    label: 'Payroll',
    actions: [
      { key: 'view', label: 'View — see Payroll set-up and employees\' payroll details', enforced: true },
      { key: 'setup', label: 'Set-up — rules, grades, benefits, projects and payers', enforced: true },
      { key: 'employees', label: "Employees — an employee's grade, payer, pay override and benefit enrolment", enforced: true },
      { key: 'inputs', label: 'Monthly Inputs — prepare and submit the month\'s deductions, adjustments and other expenses', enforced: true },
      { key: 'loans', label: 'Loans & Savings — prepare and submit payroll loans and Basic Savings plans', enforced: true },
      { key: 'runs', label: 'Payroll Runs — calculate and save the monthly run and submit it for approval', enforced: true },
      { key: 'compensation', label: 'Compensation — raise salary changes and employee allowances, benefits, bonuses and deductions for approval; set compensation budgets', enforced: true },
      { key: 'payments', label: 'Payments — create salary, statutory and other payments, submit them for approval and record them paid', enforced: true },
    ],
  },
  // One group per System Administration card (generated below from ADMIN_CARD_GROUPS).
  ...ADMIN_CARD_GROUPS,
];

const PERM_KEY = (module, action) => `${module}:${action}`;

function PermissionMatrix({ toast }) {
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  // Map<roleId, Set<permissionString>>
  const [perms, setPerms] = useState({});
  // Original snapshot for dirty detection
  const [original, setOriginal] = useState({});
  // Which modules are open. Every module starts collapsed, so the matrix opens as a one-row-per-module overview.
  const [openModules, setOpenModules] = useState({});
  // Filter to show only a subset of roles
  const [roleFilter, setRoleFilter] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await api.listRoles();
      const list = Array.isArray(r) ? r : [];
      setRoles(list);
      const map = {};
      list.forEach(role => {
        map[role.role_id] = new Set(role.permissions || []);
      });
      setPerms(map);
      // Deep-copy for dirty detection
      const orig = {};
      list.forEach(role => { orig[role.role_id] = new Set(role.permissions || []); });
      setOriginal(orig);
    } catch { }
    setLoading(false);
  }, []);

  useEffect(() => { load(); }, [load]);

  const isDirty = (roleId) => {
    const cur = perms[roleId] || new Set();
    const ori = original[roleId] || new Set();
    if (cur.size !== ori.size) return true;
    for (const p of cur) { if (!ori.has(p)) return true; }
    return false;
  };

  const dirtyRoles = roles.filter(r => isDirty(r.role_id));

  const toggle = (roleId, permKey) => {
    setPerms(prev => {
      const next = { ...prev };
      const s = new Set(next[roleId] || []);
      if (s.has(permKey)) s.delete(permKey); else s.add(permKey);
      next[roleId] = s;
      return next;
    });
  };

  const toggleModule = (roleId, moduleKey, checked) => {
    const module = MODULE_TAXONOMY.find(m => m.key === moduleKey);
    if (!module) return;
    setPerms(prev => {
      const next = { ...prev };
      const s = new Set(next[roleId] || []);
      module.actions.forEach(a => {
        const k = PERM_KEY(moduleKey, a.key);
        if (checked) s.add(k); else s.delete(k);
      });
      next[roleId] = s;
      return next;
    });
  };

  const isModuleFullyChecked = (roleId, moduleKey) => {
    const module = MODULE_TAXONOMY.find(m => m.key === moduleKey);
    if (!module) return false;
    const s = perms[roleId] || new Set();
    return module.actions.every(a => s.has(PERM_KEY(moduleKey, a.key)));
  };

  const isModulePartiallyChecked = (roleId, moduleKey) => {
    const module = MODULE_TAXONOMY.find(m => m.key === moduleKey);
    if (!module) return false;
    const s = perms[roleId] || new Set();
    const hasAny = module.actions.some(a => s.has(PERM_KEY(moduleKey, a.key)));
    const hasAll = module.actions.every(a => s.has(PERM_KEY(moduleKey, a.key)));
    return hasAny && !hasAll;
  };

  const saveAll = async () => {
    if (dirtyRoles.length === 0) return;
    setSaving(true);
    let successCount = 0;
    let errorCount = 0;
    for (const role of dirtyRoles) {
      try {
        await api.updateRole(role.role_id, { permissions: Array.from(perms[role.role_id] || []) });
        successCount++;
      } catch {
        errorCount++;
      }
    }
    setSaving(false);
    if (errorCount === 0) {
      toast.show(`Permissions saved for ${successCount} role${successCount !== 1 ? 's' : ''}.`);
    } else {
      toast.show(`Saved ${successCount}, failed ${errorCount}.`, 'error');
    }
    load();
  };

  const discardChanges = () => {
    const reset = {};
    roles.forEach(r => { reset[r.role_id] = new Set(original[r.role_id] || []); });
    setPerms(reset);
  };

  const q = roleFilter.trim().toLowerCase();
  const visibleRoles = roles.filter(r => !q || [r.display_name, r.role_name].some(v => (v || '').toLowerCase().includes(q)));

  const COL_W = 110;
  const LABEL_W = 220;

  if (loading) return <SectionLoader />;

  return (
    <div className="fade-in">
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20, flexWrap: 'wrap', gap: 12 }}>
        <div>
          <div style={{ fontSize: 18, fontWeight: 800, color: 'var(--text-primary)' }}>Permission Matrix</div>
          <div style={{ fontSize: 12.5, color: 'var(--text-secondary)', marginTop: 3 }}>
            Map system roles to granular module-level permissions. Click a checkbox to grant or revoke access.
          </div>
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
          {dirtyRoles.length > 0 && (
            <span style={{ fontSize: 12, background: '#fef3c7', color: '#92400e', border: '1px solid #fbbf24', borderRadius: 8, padding: '5px 11px', fontWeight: 700 }}>
              {dirtyRoles.length} role{dirtyRoles.length !== 1 ? 's' : ''} with unsaved changes
            </span>
          )}
          {dirtyRoles.length > 0 && (
            <Btn variant="ghost" onClick={discardChanges}>Discard</Btn>
          )}
          <Btn onClick={saveAll} loading={saving} disabled={dirtyRoles.length === 0}>
            Save Changes
          </Btn>
        </div>
      </div>

      {/* Legend + Role filter */}
      <div style={{ display: 'flex', gap: 16, alignItems: 'center', marginBottom: 16, flexWrap: 'wrap' }}>
        <input
          value={roleFilter} onChange={e => setRoleFilter(e.target.value)}
          placeholder="Filter roles…"
          style={{ padding: '7px 11px', border: '1.5px solid var(--border-strong)', borderRadius: 8, fontSize: 12.5, fontFamily: 'var(--font)', background: 'var(--bg-surface)', color: 'var(--text-primary)', width: 180 }}
        />
        <div style={{ display: 'flex', gap: 14, fontSize: 11.5, color: 'var(--text-muted)' }}>
          <span style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
            <span style={{ width: 14, height: 14, borderRadius: 4, background: 'var(--accent)', display: 'inline-block' }} /> Granted
          </span>
          <span style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
            <span style={{ width: 14, height: 14, borderRadius: 4, border: '1.5px solid var(--border-strong)', display: 'inline-block' }} /> Not Granted
          </span>
          <span style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
            <span style={{ width: 10, height: 10, borderRadius: 999, background: '#f59e0b', display: 'inline-block' }} /> Unsaved
          </span>
        </div>
        <span style={{ fontSize: 11.5, color: 'var(--text-muted)', marginLeft: 'auto' }}>
          {visibleRoles.length} role{visibleRoles.length !== 1 ? 's' : ''} · {MODULE_TAXONOMY.reduce((a, m) => a + m.actions.length, 0)} permissions
        </span>
      </div>

      {/* Matrix table */}
      <div style={{ border: '1px solid #000', borderRadius: 14, overflow: 'hidden', background: 'var(--bg-surface)' }}>
        <div style={{ overflowX: 'auto', overflowY: 'auto', maxHeight: 'calc(100vh - 340px)', minHeight: 300 }}>
          <table style={{ borderCollapse: 'collapse', minWidth: LABEL_W + visibleRoles.length * COL_W }}>
            {/* Frozen header row: it stays at the top while the permissions scroll under it (and the
                Module / Permission corner also stays put when scrolling sideways). A shadow draws the
                bottom edge, since a collapsed border does not travel with a sticky cell. */}
            <thead>
              <tr style={{ background: 'var(--bg-elevated)' }}>
                <th style={{
                  position: 'sticky', left: 0, top: 0, zIndex: 5, background: 'var(--bg-elevated)',
                  boxShadow: 'inset 0 -2px 0 var(--border)',
                  width: LABEL_W, minWidth: LABEL_W, padding: '12px 16px',
                  textAlign: 'left', borderBottom: '2px solid var(--border)', borderRight: '2px solid var(--border)',
                  fontSize: 11.5, fontWeight: 700, color: 'var(--text-secondary)', textTransform: 'uppercase', letterSpacing: '0.05em',
                }}>
                  Module / Permission
                </th>
                {visibleRoles.map(role => {
                  const dirty = isDirty(role.role_id);
                  return (
                    <th key={role.role_id} style={{
                      position: 'sticky', top: 0, zIndex: 4,
                      boxShadow: `inset 0 -2px 0 ${dirty ? '#f59e0b' : 'var(--border)'}`,
                      width: COL_W, minWidth: COL_W, padding: '8px 6px',
                      borderBottom: `2px solid ${dirty ? '#f59e0b' : 'var(--border)'}`,
                      borderRight: '1px solid var(--border-light)',
                      textAlign: 'center', verticalAlign: 'bottom',
                      background: dirty ? '#fffbeb' : 'var(--bg-elevated)',
                    }}>
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
                        {dirty && <span style={{ width: 8, height: 8, borderRadius: 999, background: '#f59e0b', flexShrink: 0 }} />}
                        <span style={{ fontSize: 11, fontWeight: 700, color: dirty ? '#92400e' : 'var(--text-primary)', lineHeight: 1.3, wordBreak: 'break-word', maxWidth: COL_W - 12 }}>
                          {role.display_name}
                        </span>
                        <span style={{ fontSize: 9.5, color: 'var(--text-muted)', fontFamily: 'var(--mono)' }}>{role.role_name}</span>
                        <span style={{ fontSize: 9.5, color: 'var(--text-secondary)' }}>
                          {(perms[role.role_id] || new Set()).size} granted
                        </span>
                      </div>
                    </th>
                  );
                })}
              </tr>
            </thead>

            <tbody>
              {MODULE_TAXONOMY.map((module, mi) => {
                const isCollapsed = !openModules[module.key];
                return (
                  <React.Fragment key={module.key}>
                    {/* Module group header row */}
                    <tr style={{ background: 'var(--bg-elevated)', borderTop: mi > 0 ? '2px solid var(--border)' : undefined }}>
                      <td style={{
                        position: 'sticky', left: 0, zIndex: 2, background: 'var(--bg-elevated)',
                        borderRight: '2px solid var(--border)', padding: '8px 10px 8px 14px',
                      }}>
                        <button
                          onClick={() => setOpenModules(o => ({ ...o, [module.key]: !o[module.key] }))}
                          style={{ display: 'flex', alignItems: 'center', gap: 7, background: 'none', border: 'none', cursor: 'pointer', fontFamily: 'var(--font)', padding: 0 }}>
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"
                            style={{ transform: isCollapsed ? 'rotate(-90deg)' : 'none', transition: 'transform 0.15s', color: 'var(--text-muted)', flexShrink: 0 }}>
                            <path d="m6 9 6 6 6-6" />
                          </svg>
                          <span style={{ fontSize: 12, fontWeight: 800, color: 'var(--text-primary)' }}>{module.label}</span>
                          {module.enforced && (
                            <span title="The server checks these: without them a role cannot make the change"
                                  style={{ marginLeft: 8, fontSize: 9.5, fontWeight: 800, letterSpacing: '0.06em', padding: '2px 7px', borderRadius: 999, background: '#dcfce7', color: '#166534', border: '1px solid #86efac' }}>
                              ENFORCED
                            </span>
                          )}
                          <span style={{ fontSize: 10, color: 'var(--text-muted)', background: 'var(--bg-surface)', borderRadius: 999, padding: '1px 6px' }}>
                            {module.actions.length}
                          </span>
                        </button>
                      </td>
                      {visibleRoles.map(role => {
                        const allChecked = isModuleFullyChecked(role.role_id, module.key);
                        const partial = isModulePartiallyChecked(role.role_id, module.key);
                        return (
                          <td key={role.role_id} style={{
                            textAlign: 'center', padding: '7px 4px',
                            borderRight: '1px solid var(--border-light)',
                            background: isDirty(role.role_id) ? '#fffbeb' : 'var(--bg-elevated)',
                          }}>
                            <input
                              type="checkbox"
                              checked={allChecked}
                              ref={el => { if (el) el.indeterminate = partial; }}
                              onChange={e => toggleModule(role.role_id, module.key, e.target.checked)}
                              title={`Toggle all ${module.label} permissions for ${role.display_name}`}
                              style={{ width: 15, height: 15, cursor: 'pointer', accentColor: 'var(--accent)' }}
                            />
                          </td>
                        );
                      })}
                    </tr>

                    {/* Action rows */}
                    {!isCollapsed && module.actions.map((action, ai) => {
                      const permKey = PERM_KEY(module.key, action.key);
                      return (
                        <tr key={permKey} style={{ borderTop: '1px solid var(--border-light)' }}
                          onMouseEnter={e => e.currentTarget.style.background = 'var(--bg-hover)'}
                          onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                          <td style={{
                            position: 'sticky', left: 0, zIndex: 1,
                            background: 'var(--bg-surface)',
                            borderRight: '2px solid var(--border)',
                            padding: '7px 10px 7px 30px',
                          }}>
                            <span style={{ fontSize: 12, color: 'var(--text-secondary)', display: 'flex', alignItems: 'center', gap: 6 }}>
                              <span style={{ width: 4, height: 4, borderRadius: 999, background: 'var(--border-strong)', flexShrink: 0 }} />
                              {action.label}
                              <span style={{ fontSize: 10, fontFamily: 'var(--mono)', color: 'var(--text-muted)', marginLeft: 4 }}>{permKey}</span>
                              {action.enforced && (
                                <span title="The system checks this tick"
                                      style={{ fontSize: 8.5, fontWeight: 800, letterSpacing: '0.06em', padding: '1px 6px', borderRadius: 999, background: '#dcfce7', color: '#166534', border: '1px solid #86efac' }}>
                                  ENFORCED
                                </span>
                              )}
                            </span>
                          </td>
                          {visibleRoles.map(role => {
                            const granted = (perms[role.role_id] || new Set()).has(permKey);
                            return (
                              <td key={role.role_id} style={{
                                textAlign: 'center', padding: '6px 4px',
                                borderRight: '1px solid var(--border-light)',
                                background: granted
                                  ? 'color-mix(in srgb, var(--accent) 8%, transparent)'
                                  : isDirty(role.role_id) ? '#fffbeb' : 'transparent',
                              }}>
                                <input
                                  type="checkbox"
                                  checked={granted}
                                  onChange={() => toggle(role.role_id, permKey)}
                                  title={`${granted ? 'Revoke' : 'Grant'} ${permKey} for ${role.display_name}`}
                                  style={{ width: 15, height: 15, cursor: 'pointer', accentColor: 'var(--accent)' }}
                                />
                              </td>
                            );
                          })}
                        </tr>
                      );
                    })}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* Footer bar */}
        <div style={{
          borderTop: '1px solid #000', padding: '10px 16px',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          background: 'var(--bg-elevated)', gap: 12, flexWrap: 'wrap',
        }}>
          <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>
            Tip: Use the module header checkboxes to grant or revoke all permissions in a module at once.
          </span>
          <div style={{ display: 'flex', gap: 8 }}>
            {dirtyRoles.length > 0 && <Btn variant="ghost" onClick={discardChanges}>Discard Changes</Btn>}
            <Btn onClick={saveAll} loading={saving} disabled={dirtyRoles.length === 0}>
              {dirtyRoles.length > 0 ? `Save ${dirtyRoles.length} Role${dirtyRoles.length !== 1 ? 's' : ''}` : 'No Changes'}
            </Btn>
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── ORG HIERARCHY ───────────────────────────────────────────────────────────

// `enforced`: the approval engine refuses an approve above the ceiling
// (backend/app/services/approval_limit_service.py → ENTITY_MODULE). BOQ Hub has
// no approval workflow yet, so a limit there is recorded but has nothing to stop.
const APPROVAL_MODULES = [
  { key: 'enterprise_requisition', label: 'Enterprise Requisition', basis: 'Requisition total incl. VAT', enforced: true },
  { key: 'payment_voucher', label: 'Payment Voucher', basis: 'Amount payable (gross + VAT), in NGN', enforced: true },
  { key: 'material_request', label: 'Material Request', basis: 'Sum of line totals (Cost Control figure once reviewed)', enforced: true },
  { key: 'material_po', label: 'Material Purchase Orders', basis: 'PO grand total', enforced: true },
  { key: 'overtime_authorization', label: 'Overtime Authorization', basis: 'Overtime amount (hours × rate × multiplier)', enforced: true },
  { key: 'leave_monetization', label: 'Leave Monetization', basis: 'Gross monetization amount', enforced: true },
  { key: 'missed_day_posting', label: 'Missed Day Payroll Posting', basis: 'Total deductions in the posting batch', enforced: true },
  { key: 'boq_hub', label: 'BOQ Hub', basis: 'No approval workflow yet', enforced: false },
];

const MOD_MODULES = [
  { key: 'enterprise_requisition', label: 'Enterprise Requisition' },
  { key: 'payment_voucher', label: 'Payment Voucher' },
  { key: 'material_request', label: 'Material Request' },
  { key: 'material_po', label: 'Material Purchase Orders' },
  { key: 'expense_master', label: 'Expense Master' },
];

// ── Small reusable modal shell ──────────────────────────────────────────────
function OrgModal({ title, onClose, children, onSave, saving }) {
  return (
    <Modal onClose={onClose}>
      <div style={{ padding: '24px 28px', minWidth: 380, maxWidth: 480 }}>
        <div style={{ fontSize: 16, fontWeight: 800, marginBottom: 20, color: 'var(--text-primary)' }}>{title}</div>
        {children}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 22 }}>
          <Btn variant="ghost" onClick={onClose}>Cancel</Btn>
          <Btn onClick={onSave} loading={saving}>Save</Btn>
        </div>
      </div>
    </Modal>
  );
}

function OrgHierarchy({ toast }) {
  const [tree, setTree] = useState([]);
  const [loading, setLoading] = useState(true);
  // expanded state for tree nodes: Set of ids
  const [expanded, setExpanded] = useState(new Set());
  // modal: { type: 'company'|'state'|'branch'|'site', mode: 'create'|'edit', parent: obj|null, item: obj|null }
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try { setTree(await api.getOrgTree()); } catch {}
    setLoading(false);
  }, []);

  useEffect(() => { load(); }, [load]);

  const toggle = (id) => setExpanded(e => {
    const n = new Set(e);
    n.has(id) ? n.delete(id) : n.add(id);
    return n;
  });

  const openCreate = (type, parent) => { setForm({}); setModal({ type, mode: 'create', parent }); };
  const openEdit = (type, item) => {
    setForm({ ...item, ...(type === 'site' ? { aliases_text: (item.aliases || []).join(', ') } : {}) });
    setModal({ type, mode: 'edit', item });
  };

  const save = async () => {
    setSaving(true);
    try {
      const { type, mode, parent, item } = modal;
      const { aliases_text: aliasesText, ...payload } = form;
      // a site's other names (Attendance Import matches pasted reports by name or alias)
      if (type === 'site') payload.aliases = (aliasesText || '').split(',').map(a => a.trim()).filter(Boolean);
      if (mode === 'create') {
        if (type === 'state') payload.company_id = parent.id;
        if (type === 'branch') payload.state_id = parent.id;
        if (type === 'site') payload.branch_id = parent.id;
        if (type === 'company') await api.createCompany(payload);
        else if (type === 'state') await api.createOrgState(payload);
        else if (type === 'branch') await api.createOrgBranch(payload);
        else await api.createOrgSite(payload);
        toast.show('Created successfully.');
        if (parent) setExpanded(e => new Set([...e, parent.id]));
      } else {
        if (type === 'company') await api.updateCompany(item.id, payload);
        else if (type === 'state') await api.updateOrgState(item.id, payload);
        else if (type === 'branch') await api.updateOrgBranch(item.id, payload);
        else await api.updateOrgSite(item.id, payload);
        toast.show('Updated.');
      }
      setModal(null);
      load();
    } catch (e) {
      toast.show(e?.message || 'Save failed.', 'error');
    }
    setSaving(false);
  };

  const del = async (type, id) => {
    setDeleting(id);
    try {
      if (type === 'company') await api.deleteCompany(id);
      else if (type === 'state') await api.deleteOrgState(id);
      else if (type === 'branch') await api.deleteOrgBranch(id);
      else await api.deleteOrgSite(id);
      toast.show('Deleted.');
      load();
    } catch { toast.show('Delete failed.', 'error'); }
    setDeleting(null);
  };

  const NodeRow = ({ type, item, depth, children }) => {
    const hasChildren = children && React.Children.count(children) > 0;
    const isOpen = expanded.has(item.id);
    const typeColors = { company: '#3b82f6', state: '#8b5cf6', branch: '#f59e0b', site: '#10b981' };
    const typeLabels = { company: 'Company', state: 'State', branch: 'Branch', site: 'Site' };
    return (
      <>
        <div style={{
          display: 'flex', alignItems: 'center', gap: 8, padding: '8px 12px 8px',
          paddingLeft: 12 + depth * 22,
          borderBottom: '1px solid var(--border-light)',
          background: 'var(--bg-surface)',
        }}
          onMouseEnter={e => e.currentTarget.style.background = 'var(--bg-hover)'}
          onMouseLeave={e => e.currentTarget.style.background = 'var(--bg-surface)'}
        >
          <button
            onClick={() => hasChildren && toggle(item.id)}
            style={{ background: 'none', border: 'none', cursor: hasChildren ? 'pointer' : 'default', padding: 2, flexShrink: 0 }}
          >
            {hasChildren
              ? <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"
                  style={{ transform: isOpen ? 'none' : 'rotate(-90deg)', transition: 'transform 0.15s', color: 'var(--text-muted)' }}>
                  <path d="m6 9 6 6 6-6" />
                </svg>
              : <span style={{ width: 12, display: 'inline-block' }} />
            }
          </button>
          <span style={{ width: 6, height: 6, borderRadius: 999, background: typeColors[type], flexShrink: 0 }} />
          <span style={{ fontSize: 12, color: 'var(--text-primary)', flex: 1, fontWeight: type === 'company' ? 700 : 500 }}>
            {item.name}
          </span>
          <span style={{ fontSize: 10.5, fontFamily: 'var(--mono)', color: 'var(--text-muted)', background: 'var(--bg-elevated)', borderRadius: 6, padding: '2px 6px' }}>
            {item.code}
          </span>
          <span style={{ fontSize: 10, color: typeColors[type], background: `${typeColors[type]}18`, borderRadius: 6, padding: '2px 7px', fontWeight: 600 }}>
            {typeLabels[type]}
          </span>
          {!item.is_active && (
            <span style={{ fontSize: 10, color: '#6b7280', background: '#f3f4f6', borderRadius: 6, padding: '2px 7px' }}>Inactive</span>
          )}
          <div style={{ display: 'flex', gap: 4, marginLeft: 6 }}>
            {type !== 'site' && (
              <button
                onClick={() => openCreate(
                  type === 'company' ? 'state' : type === 'state' ? 'branch' : 'site',
                  item
                )}
                title={`Add ${type === 'company' ? 'State' : type === 'state' ? 'Branch' : 'Site'}`}
                style={{ background: 'none', border: '1px solid #000', borderRadius: 6, cursor: 'pointer', padding: '3px 7px', fontSize: 11, color: 'var(--accent)', fontWeight: 700 }}>
                + {type === 'company' ? 'State' : type === 'state' ? 'Branch' : 'Site'}
              </button>
            )}
            <button onClick={() => openEdit(type, item)}
              style={{ background: 'none', border: '1px solid #000', borderRadius: 6, cursor: 'pointer', padding: '3px 7px', fontSize: 11, color: 'var(--text-secondary)' }}>
              Edit
            </button>
            <button onClick={() => del(type, item.id)} disabled={deleting === item.id}
              style={{ background: 'none', border: '1.5px solid #fca5a5', borderRadius: 6, cursor: 'pointer', padding: '3px 7px', fontSize: 11, color: '#ef4444' }}>
              {deleting === item.id ? '…' : 'Del'}
            </button>
          </div>
        </div>
        {isOpen && children}
      </>
    );
  };

  const MODAL_FIELDS = {
    company: [
      { key: 'name', label: 'Company Name', required: true },
      { key: 'code', label: 'Code', required: true },
      { key: 'address', label: 'Address' },
      { key: 'phone', label: 'Phone' },
      { key: 'email', label: 'Email' },
    ],
    state: [
      { key: 'name', label: 'State Name', required: true },
      { key: 'code', label: 'Code', required: true },
    ],
    branch: [
      { key: 'name', label: 'Branch Name', required: true },
      { key: 'code', label: 'Code', required: true },
      { key: 'address', label: 'Address' },
      { key: 'phone', label: 'Phone' },
    ],
    site: [
      { key: 'name', label: 'Site Name', required: true },
      { key: 'code', label: 'Code', required: true },
      { key: 'address', label: 'Address' },
      { key: 'is_outstation', label: 'Outstation site (staff paid a daily allowance here)', type: 'checkbox' },
      { key: 'outstation_allowance', label: 'Daily Outstation Allowance (₦)', type: 'number', showIf: f => f.is_outstation },
      { key: 'tp_eligible', label: 'Site transport (TP) is paid for each day worked here', type: 'checkbox' },
      { key: 'aliases_text', label: 'Other names on attendance reports (comma-separated)' },
    ],
  };

  if (loading) return <SectionLoader />;

  const totalNodes = tree.reduce((a, c) =>
    a + 1 + (c.states || []).reduce((b, s) =>
      b + 1 + (s.branches || []).reduce((d, br) => d + 1 + (br.sites || []).length, 0), 0), 0);

  return (
    <div className="fade-in">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 }}>
        <div>
          <div style={{ fontSize: 18, fontWeight: 800, color: 'var(--text-primary)' }}>Company / Branch / State / Site</div>
          <div style={{ fontSize: 12.5, color: 'var(--text-secondary)', marginTop: 3 }}>
            Build and manage your organisational hierarchy. {totalNodes} node{totalNodes !== 1 ? 's' : ''} defined.
          </div>
        </div>
        <Btn onClick={() => openCreate('company', null)}>+ Add Company</Btn>
      </div>

      {/* Legend */}
      <div style={{ display: 'flex', gap: 16, marginBottom: 16, flexWrap: 'wrap' }}>
        {[['company', '#3b82f6'], ['state', '#8b5cf6'], ['branch', '#f59e0b'], ['site', '#10b981']].map(([t, c]) => (
          <span key={t} style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 11.5, color: 'var(--text-muted)' }}>
            <span style={{ width: 8, height: 8, borderRadius: 999, background: c }} />
            {t.charAt(0).toUpperCase() + t.slice(1)}
          </span>
        ))}
      </div>

      {/* Tree */}
      <div style={{ border: '1px solid #000', borderRadius: 12, overflow: 'hidden', background: 'var(--bg-surface)' }}>
        {tree.length === 0
          ? <div style={{ textAlign: 'center', padding: 48, color: 'var(--text-muted)', fontSize: 13 }}>
              No companies defined yet. Click <strong>+ Add Company</strong> to start.
            </div>
          : tree.map(company => (
            <NodeRow key={company.id} type="company" item={company} depth={0}>
              {(company.states || []).map(state => (
                <NodeRow key={state.id} type="state" item={state} depth={1}>
                  {(state.branches || []).map(branch => (
                    <NodeRow key={branch.id} type="branch" item={branch} depth={2}>
                      {(branch.sites || []).map(site => (
                        <NodeRow key={site.id} type="site" item={site} depth={3} />
                      ))}
                    </NodeRow>
                  ))}
                </NodeRow>
              ))}
            </NodeRow>
          ))
        }
      </div>

      {/* Create / Edit Modal */}
      {modal && (
        <OrgModal
          title={`${modal.mode === 'create' ? 'Add' : 'Edit'} ${modal.type.charAt(0).toUpperCase() + modal.type.slice(1)}`}
          onClose={() => setModal(null)}
          onSave={save}
          saving={saving}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            {(MODAL_FIELDS[modal.type] || []).filter(f => !f.showIf || f.showIf(form)).map(f => (f.type === 'checkbox' ? (
              <div key={f.key} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <input type="checkbox" id={`org_${f.key}`} checked={!!form[f.key]}
                  onChange={e => setForm(p => ({ ...p, [f.key]: e.target.checked }))}
                  style={{ accentColor: 'var(--accent)' }} />
                <label htmlFor={`org_${f.key}`} style={{ fontSize: 12.5, color: 'var(--text-secondary)' }}>{f.label}</label>
              </div>
            ) : (
              <div key={f.key}>
                <div style={{ fontSize: 11.5, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 5 }}>
                  {f.label}{f.required && ' *'}
                </div>
                <Input
                  type={f.type || 'text'}
                  value={form[f.key] ?? ''}
                  onChange={v => setForm(p => ({ ...p, [f.key]: v }))}
                  placeholder={f.label}
                />
              </div>
            )))}
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <input type="checkbox" id="is_active_org" checked={form.is_active !== false}
                onChange={e => setForm(p => ({ ...p, is_active: e.target.checked }))}
                style={{ accentColor: 'var(--accent)' }} />
              <label htmlFor="is_active_org" style={{ fontSize: 12.5, color: 'var(--text-secondary)' }}>Active</label>
            </div>
          </div>
        </OrgModal>
      )}
    </div>
  );
}

// ─── APPROVAL LIMITS ─────────────────────────────────────────────────────────

function ApprovalLimits({ toast }) {
  const [roles, setRoles] = useState([]);
  const [limits, setLimits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  // local: Map of `${roleId}:${module}` → amount string ('' = unlimited)
  const [local, setLocal] = useState({});
  const [original, setOriginal] = useState({});

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const [r, l] = await Promise.all([api.listRoles(), api.listApprovalLimits()]);
      setRoles(Array.isArray(r) ? r : []);
      setLimits(Array.isArray(l) ? l : []);
      const map = {};
      (Array.isArray(l) ? l : []).forEach(row => {
        map[`${row.role_id}:${row.module}`] = row.max_amount != null ? String(row.max_amount) : '';
      });
      setLocal(map);
      setOriginal({ ...map });
    } catch {}
    setLoading(false);
  }, []);

  useEffect(() => { load(); }, [load]);

  const isDirty = () => JSON.stringify(local) !== JSON.stringify(original);

  const setCell = (roleId, module, val) => {
    setLocal(p => ({ ...p, [`${roleId}:${module}`]: val }));
  };

  const saveAll = async () => {
    setSaving(true);
    const dirty = Object.entries(local).filter(([k, v]) => v !== (original[k] || ''));
    let ok = 0; let fail = 0;
    for (const [key, val] of dirty) {
      const [roleId, module] = key.split(':');
      try {
        await api.upsertApprovalLimit({
          role_id: roleId, module,
          max_amount: val === '' ? null : parseFloat(val),
          is_active: true,
        });
        ok++;
      } catch { fail++; }
    }
    setSaving(false);
    if (fail === 0) toast.show(`Saved ${ok} limit${ok !== 1 ? 's' : ''}.`);
    else toast.show(`Saved ${ok}, failed ${fail}.`, 'error');
    load();
  };

  const dirtyCount = Object.entries(local).filter(([k, v]) => v !== (original[k] || '')).length;

  if (loading) return <SectionLoader />;

  return (
    <div className="fade-in">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20, flexWrap: 'wrap', gap: 12 }}>
        <div>
          <div style={{ fontSize: 18, fontWeight: 800, color: 'var(--text-primary)' }}>Approval Limit Setup</div>
          <div style={{ fontSize: 12.5, color: 'var(--text-secondary)', marginTop: 3 }}>
            Set financial approval ceilings per role and document type. Leave blank for unlimited.
          </div>
          <div style={{ fontSize: 12, color: 'var(--text-secondary)', marginTop: 6, lineHeight: 1.5, maxWidth: 760 }}>
            An approver cannot <b>approve</b> a document above the highest limit among the roles they hold at that
            approval step — they can still return or reject it. Roles with no limit set are not restricted.
          </div>
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          {dirtyCount > 0 && (
            <span style={{ fontSize: 12, background: '#fef3c7', color: '#92400e', border: '1px solid #fbbf24', borderRadius: 8, padding: '5px 11px', fontWeight: 700 }}>
              {dirtyCount} unsaved change{dirtyCount !== 1 ? 's' : ''}
            </span>
          )}
          <Btn onClick={saveAll} loading={saving} disabled={dirtyCount === 0}>Save Changes</Btn>
        </div>
      </div>

      <div style={{ border: '1px solid #000', borderRadius: 14, overflow: 'hidden', background: 'var(--bg-surface)' }}>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ borderCollapse: 'collapse', minWidth: 200 + roles.length * 140 }}>
            <thead>
              <tr style={{ background: 'var(--bg-elevated)' }}>
                <th style={{
                  position: 'sticky', left: 0, zIndex: 2, background: 'var(--bg-elevated)',
                  padding: '11px 16px', textAlign: 'left', borderBottom: '2px solid var(--border)',
                  borderRight: '2px solid var(--border)', fontSize: 11.5, fontWeight: 700,
                  color: 'var(--text-secondary)', textTransform: 'uppercase', letterSpacing: '0.05em', minWidth: 200,
                }}>
                  Document Type / Role →
                </th>
                {roles.map(r => (
                  <th key={r.role_id} style={{
                    padding: '10px 8px', borderBottom: '2px solid var(--border)', borderRight: '1px solid var(--border-light)',
                    textAlign: 'center', minWidth: 140,
                  }}>
                    <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--text-primary)' }}>{r.display_name}</div>
                    <div style={{ fontSize: 9.5, color: 'var(--text-muted)', fontFamily: 'var(--mono)' }}>{r.role_name}</div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {APPROVAL_MODULES.map((mod, mi) => (
                <tr key={mod.key} style={{ borderTop: mi > 0 ? '1px solid var(--border-light)' : undefined }}>
                  <td style={{
                    position: 'sticky', left: 0, zIndex: 1, background: 'var(--bg-surface)',
                    borderRight: '2px solid var(--border)', padding: '10px 16px',
                    fontSize: 12.5, fontWeight: 600, color: 'var(--text-primary)',
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                      {mod.label}
                      <span title={mod.enforced ? 'The approval engine refuses approvals above the limit' : 'Saved, but nothing is approved here yet'}
                            style={{ fontSize: 9, fontWeight: 800, letterSpacing: '0.06em', padding: '2px 6px', borderRadius: 999,
                                     background: mod.enforced ? '#dcfce7' : '#f1f5f9', color: mod.enforced ? '#166534' : '#64748b',
                                     border: `1px solid ${mod.enforced ? '#86efac' : '#cbd5e1'}` }}>
                        {mod.enforced ? 'ENFORCED' : 'NOT ENFORCED'}
                      </span>
                    </div>
                    <div style={{ fontSize: 10.5, fontWeight: 500, color: 'var(--text-muted)', marginTop: 2 }}>{mod.basis}</div>
                  </td>
                  {roles.map(r => {
                    const key = `${r.role_id}:${mod.key}`;
                    const val = local[key] ?? '';
                    const changed = val !== (original[key] || '');
                    return (
                      <td key={r.role_id} style={{
                        padding: '7px 8px', borderRight: '1px solid var(--border-light)',
                        textAlign: 'center', background: changed ? '#fffbeb' : 'transparent',
                      }}>
                        <input
                          type="number" min="0" step="0.01"
                          value={val}
                          onChange={e => setCell(r.role_id, mod.key, e.target.value)}
                          placeholder="Unlimited"
                          style={{
                            width: 110, padding: '6px 9px', border: `1.5px solid ${changed ? '#f59e0b' : 'var(--border)'}`,
                            borderRadius: 8, fontSize: 12, fontFamily: 'var(--font)',
                            background: 'var(--bg-surface)', color: 'var(--text-primary)', textAlign: 'right',
                          }}
                        />
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div style={{ padding: '10px 16px', borderTop: '1px solid #000', background: 'var(--bg-elevated)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>
            Currency: NGN. Leave a cell blank to allow unlimited approval authority for that role.
          </span>
          <Btn onClick={saveAll} loading={saving} disabled={dirtyCount === 0}>
            {dirtyCount > 0 ? `Save ${dirtyCount} Change${dirtyCount !== 1 ? 's' : ''}` : 'No Changes'}
          </Btn>
        </div>
      </div>
    </div>
  );
}

// ─── MODIFICATION ACCESS CONTROL ─────────────────────────────────────────────

function ModificationAccessControl({ toast }) {
  const [roles, setRoles] = useState([]);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  // local: Map of `${roleId}:${module}` → { can_modify, can_void, can_reverse, max_days }
  const [local, setLocal] = useState({});
  const [original, setOriginal] = useState({});

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const [r, ma] = await Promise.all([api.listRoles(), api.listModificationAccess()]);
      setRoles(Array.isArray(r) ? r : []);
      setRows(Array.isArray(ma) ? ma : []);
      const map = {};
      (Array.isArray(ma) ? ma : []).forEach(row => {
        map[`${row.role_id}:${row.module}`] = {
          can_modify: !!row.can_modify, can_void: !!row.can_void,
          can_reverse: !!row.can_reverse,
          max_days: row.max_days_after_posting != null ? String(row.max_days_after_posting) : '',
        };
      });
      setLocal(map);
      setOriginal(JSON.parse(JSON.stringify(map)));
    } catch {}
    setLoading(false);
  }, []);

  useEffect(() => { load(); }, [load]);

  const getCell = (roleId, module) =>
    local[`${roleId}:${module}`] || { can_modify: false, can_void: false, can_reverse: false, max_days: '' };

  const setField = (roleId, module, field, val) => {
    const key = `${roleId}:${module}`;
    setLocal(p => ({ ...p, [key]: { ...(p[key] || { can_modify: false, can_void: false, can_reverse: false, max_days: '' }), [field]: val } }));
  };

  const isDirtyCount = () => {
    let n = 0;
    for (const k of Object.keys(local)) {
      if (JSON.stringify(local[k]) !== JSON.stringify(original[k] || { can_modify: false, can_void: false, can_reverse: false, max_days: '' })) n++;
    }
    return n;
  };

  const saveAll = async () => {
    setSaving(true);
    let ok = 0; let fail = 0;
    for (const [key, val] of Object.entries(local)) {
      const orig = original[key] || { can_modify: false, can_void: false, can_reverse: false, max_days: '' };
      if (JSON.stringify(val) === JSON.stringify(orig)) continue;
      const [roleId, module] = key.split(':');
      try {
        await api.upsertModificationAccess({
          role_id: roleId, module,
          can_modify: val.can_modify, can_void: val.can_void, can_reverse: val.can_reverse,
          max_days_after_posting: val.max_days === '' ? null : parseInt(val.max_days, 10),
          is_active: true,
        });
        ok++;
      } catch { fail++; }
    }
    setSaving(false);
    if (fail === 0) toast.show(`Saved ${ok} entr${ok !== 1 ? 'ies' : 'y'}.`);
    else toast.show(`Saved ${ok}, failed ${fail}.`, 'error');
    load();
  };

  const dirtyCount = isDirtyCount();

  if (loading) return <SectionLoader />;

  return (
    <div className="fade-in">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20, flexWrap: 'wrap', gap: 12 }}>
        <div>
          <div style={{ fontSize: 18, fontWeight: 800, color: 'var(--text-primary)' }}>Modification Access Control</div>
          <div style={{ fontSize: 12.5, color: 'var(--text-secondary)', marginTop: 3 }}>
            Control which roles can edit, void, or reverse posted and approved records. Optionally set a time window.
          </div>
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          {dirtyCount > 0 && (
            <span style={{ fontSize: 12, background: '#fef3c7', color: '#92400e', border: '1px solid #fbbf24', borderRadius: 8, padding: '5px 11px', fontWeight: 700 }}>
              {dirtyCount} unsaved change{dirtyCount !== 1 ? 's' : ''}
            </span>
          )}
          <Btn onClick={saveAll} loading={saving} disabled={dirtyCount === 0}>Save Changes</Btn>
        </div>
      </div>

      {/* Legend */}
      <div style={{ display: 'flex', gap: 16, marginBottom: 14, fontSize: 11.5, color: 'var(--text-muted)', flexWrap: 'wrap' }}>
        <span><strong style={{ color: 'var(--text-primary)' }}>Modify</strong> = Edit fields on approved/posted records</span>
        <span><strong style={{ color: 'var(--text-primary)' }}>Void</strong> = Cancel the record entirely</span>
        <span><strong style={{ color: 'var(--text-primary)' }}>Reverse</strong> = Create a reversing entry</span>
        <span><strong style={{ color: 'var(--text-primary)' }}>Days</strong> = Max days after posting (blank = no limit)</span>
      </div>

      <div style={{ border: '1px solid #000', borderRadius: 14, overflow: 'hidden', background: 'var(--bg-surface)' }}>
        <div style={{ overflowX: 'auto', maxHeight: 'calc(100vh - 340px)' }}>
          <table style={{ borderCollapse: 'collapse', minWidth: 260 + roles.length * 200 }}>
            <thead>
              <tr style={{ background: 'var(--bg-elevated)' }}>
                <th style={{
                  position: 'sticky', left: 0, zIndex: 2, background: 'var(--bg-elevated)',
                  padding: '11px 16px', textAlign: 'left', borderBottom: '2px solid var(--border)',
                  borderRight: '2px solid var(--border)', fontSize: 11.5, fontWeight: 700,
                  color: 'var(--text-secondary)', textTransform: 'uppercase', letterSpacing: '0.05em', minWidth: 200,
                }}>
                  Module / Role →
                </th>
                {roles.map(r => (
                  <th key={r.role_id} style={{
                    padding: '10px 8px', borderBottom: '2px solid var(--border)',
                    borderRight: '1px solid var(--border-light)', textAlign: 'center', minWidth: 200,
                  }}>
                    <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--text-primary)' }}>{r.display_name}</div>
                    <div style={{ fontSize: 9.5, color: 'var(--text-muted)', fontFamily: 'var(--mono)' }}>{r.role_name}</div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {MOD_MODULES.map((mod, mi) => (
                <tr key={mod.key} style={{ borderTop: mi > 0 ? '1px solid var(--border-light)' : undefined }}>
                  <td style={{
                    position: 'sticky', left: 0, zIndex: 1, background: 'var(--bg-surface)',
                    borderRight: '2px solid var(--border)', padding: '10px 16px',
                    fontSize: 12.5, fontWeight: 600, color: 'var(--text-primary)',
                  }}>
                    {mod.label}
                  </td>
                  {roles.map(r => {
                    const cell = getCell(r.role_id, mod.key);
                    const orig = original[`${r.role_id}:${mod.key}`];
                    const changed = JSON.stringify(cell) !== JSON.stringify(orig || { can_modify: false, can_void: false, can_reverse: false, max_days: '' });
                    return (
                      <td key={r.role_id} style={{
                        padding: '8px 10px', borderRight: '1px solid var(--border-light)',
                        background: changed ? '#fffbeb' : 'transparent', verticalAlign: 'middle',
                      }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
                          {[['can_modify', 'Modify'], ['can_void', 'Void'], ['can_reverse', 'Reverse']].map(([field, label]) => (
                            <label key={field} style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: 11.5 }}>
                              <input type="checkbox" checked={!!cell[field]}
                                onChange={e => setField(r.role_id, mod.key, field, e.target.checked)}
                                style={{ accentColor: 'var(--accent)', width: 13, height: 13 }} />
                              <span style={{ color: cell[field] ? 'var(--text-primary)' : 'var(--text-muted)' }}>{label}</span>
                            </label>
                          ))}
                          {(cell.can_modify || cell.can_void || cell.can_reverse) && (
                            <div style={{ display: 'flex', alignItems: 'center', gap: 5, marginTop: 2 }}>
                              <span style={{ fontSize: 10.5, color: 'var(--text-muted)' }}>Days:</span>
                              <input
                                type="number" min="0" step="1" value={cell.max_days}
                                onChange={e => setField(r.role_id, mod.key, 'max_days', e.target.value)}
                                placeholder="∞"
                                style={{ width: 60, padding: '3px 6px', border: '1px solid #000', borderRadius: 6, fontSize: 11, fontFamily: 'var(--font)', background: 'var(--bg-surface)', color: 'var(--text-primary)' }}
                              />
                            </div>
                          )}
                        </div>
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div style={{ padding: '10px 16px', borderTop: '1px solid #000', background: 'var(--bg-elevated)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>
            Changes take effect immediately on save. The "Days" field only appears when at least one flag is enabled.
          </span>
          <Btn onClick={saveAll} loading={saving} disabled={dirtyCount === 0}>
            {dirtyCount > 0 ? `Save ${dirtyCount} Change${dirtyCount !== 1 ? 's' : ''}` : 'No Changes'}
          </Btn>
        </div>
      </div>
    </div>
  );
}

// ─── YEAR ACCESS CONTROL ─────────────────────────────────────────────────────

const YEAR_STATUS = {
  open:   { label: 'Open',   color: '#10b981', bg: '#d1fae5' },
  locked: { label: 'Locked', color: '#f59e0b', bg: '#fef3c7' },
  closed: { label: 'Closed', color: '#ef4444', bg: '#fee2e2' },
};

function yearStatus(fy) {
  if (fy.is_closed) return 'closed';
  if (fy.is_locked) return 'locked';
  return 'open';
}

function YearAccessControl({ toast }) {
  const [years, setYears] = useState([]);
  const [users, setUsers] = useState([]);
  const [accessMap, setAccessMap] = useState({}); // `${userId}:${yearId}` → { id, can_view, can_post }
  const [loading, setLoading] = useState(true);

  // Year form modal
  const [yearModal, setYearModal] = useState(null); // null | { mode: 'create'|'edit', item?: fy }
  const [yearForm, setYearForm] = useState({});
  const [savingYear, setSavingYear] = useState(false);

  // User filter for the matrix
  const [userQ, setUserQ] = useState('');

  // Pending matrix changes: Map of `${userId}:${yearId}` → { can_view, can_post }
  const [pending, setPending] = useState({});
  const [savingMatrix, setSavingMatrix] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const [fy, u, acc] = await Promise.all([
        api.listFiscalYears(),
        api.listUsers({ skip: 0, limit: 200 }),
        api.listUserYearAccess(),
      ]);
      setYears(Array.isArray(fy) ? fy : []);
      const uList = Array.isArray(u) ? u : (u?.users || []);
      setUsers(uList);
      const map = {};
      (Array.isArray(acc) ? acc : []).forEach(row => {
        map[`${row.user_id}:${row.fiscal_year_id}`] = {
          id: row.id, can_view: !!row.can_view, can_post: !!row.can_post,
        };
      });
      setAccessMap(map);
      setPending({});
    } catch {}
    setLoading(false);
  }, []);

  useEffect(() => { load(); }, [load]);

  // ── Year management ──────────────────────────────────────────────────────

  const openCreateYear = () => {
    const nextYear = (years[0]?.year || new Date().getFullYear()) + (years.length === 0 ? 0 : 1);
    setYearForm({ year: nextYear, label: `FY ${nextYear}`, is_locked: false, is_closed: false, is_active: true });
    setYearModal({ mode: 'create' });
  };

  const openEditYear = (fy) => {
    setYearForm({ ...fy, start_date: fy.start_date || '', end_date: fy.end_date || '' });
    setYearModal({ mode: 'edit', item: fy });
  };

  const saveYear = async () => {
    setSavingYear(true);
    try {
      const data = { ...yearForm };
      if (!data.start_date) data.start_date = null;
      if (!data.end_date) data.end_date = null;
      if (yearModal.mode === 'create') {
        await api.createFiscalYear(data);
        toast.show('Fiscal year created.');
      } else {
        await api.updateFiscalYear(yearModal.item.id, data);
        toast.show('Fiscal year updated.');
      }
      setYearModal(null);
      load();
    } catch (e) { toast.show(e?.message || 'Save failed.', 'error'); }
    setSavingYear(false);
  };

  const deleteYear = async (fy) => {
    try {
      await api.deleteFiscalYear(fy.id);
      toast.show('Fiscal year deleted.');
      load();
    } catch { toast.show('Delete failed.', 'error'); }
  };

  const quickToggle = async (fy, field) => {
    try {
      await api.updateFiscalYear(fy.id, {
        ...fy, start_date: fy.start_date || null, end_date: fy.end_date || null,
        [field]: !fy[field],
        // closing overrides locked
        ...(field === 'is_closed' && !fy.is_closed ? { is_locked: true } : {}),
      });
      load();
    } catch { toast.show('Update failed.', 'error'); }
  };

  // ── Access matrix ────────────────────────────────────────────────────────

  const getCell = (userId, yearId) => {
    const key = `${userId}:${yearId}`;
    if (pending[key] !== undefined) return pending[key];
    const saved = accessMap[key];
    if (saved) return { can_view: saved.can_view, can_post: saved.can_post };
    return null; // no access
  };

  const setCell = (userId, yearId, field, val) => {
    const key = `${userId}:${yearId}`;
    const current = getCell(userId, yearId) || { can_view: false, can_post: false };
    setPending(p => ({ ...p, [key]: { ...current, [field]: val } }));
  };

  const dirtyCount = Object.keys(pending).length;

  const saveMatrix = async () => {
    setSavingMatrix(true);
    let ok = 0; let fail = 0;
    for (const [key, val] of Object.entries(pending)) {
      const [userId, yearId] = key.split(':');
      try {
        if (!val.can_view && !val.can_post) {
          // Remove access if both flags off and a row exists
          const existing = accessMap[key];
          if (existing?.id) await api.deleteUserYearAccess(existing.id);
        } else {
          await api.upsertUserYearAccess({ user_id: userId, fiscal_year_id: yearId, ...val });
        }
        ok++;
      } catch { fail++; }
    }
    setSavingMatrix(false);
    if (fail === 0) toast.show(`Saved ${ok} access entr${ok !== 1 ? 'ies' : 'y'}.`);
    else toast.show(`Saved ${ok}, failed ${fail}.`, 'error');
    load();
  };

  const grantAllYears = async (userId) => {
    const updates = {};
    years.forEach(fy => {
      if (!fy.is_closed) {
        updates[`${userId}:${fy.id}`] = { can_view: true, can_post: !fy.is_locked };
      }
    });
    setPending(p => ({ ...p, ...updates }));
  };

  const revokeAllYears = (userId) => {
    const updates = {};
    years.forEach(fy => { updates[`${userId}:${fy.id}`] = { can_view: false, can_post: false }; });
    setPending(p => ({ ...p, ...updates }));
  };

  const filteredUsers = users.filter(u => {
    if (!userQ.trim()) return true;
    const q = userQ.toLowerCase();
    return [u.email, u.first_name, u.last_name].some(v => (v || '').toLowerCase().includes(q));
  });

  if (loading) return <SectionLoader />;

  return (
    <div className="fade-in">
      <div style={{ fontSize: 18, fontWeight: 800, color: 'var(--text-primary)', marginBottom: 4 }}>Year Access Control</div>
      <div style={{ fontSize: 12.5, color: 'var(--text-secondary)', marginBottom: 8 }}>
        Define fiscal years and control which users can view or post into each year.
      </div>
      <div style={{ fontSize: 12, color: 'var(--text-secondary)', marginBottom: 24, lineHeight: 1.55, maxWidth: 820,
        border: '1px solid var(--border-light)', borderRadius: 10, padding: '10px 14px', background: 'var(--bg-base)' }}>
        <b style={{ color: 'var(--text-primary)' }}>Enforced when money is posted</b> — submitting, correcting or releasing a payment voucher,
        and recording, changing or deleting labour, material, other-cost and expense entries — using the entry's date:
        a <b>Closed</b> or <b>Locked</b> year takes nothing (unlock it to post); once a year has access set for anyone,
        only users ticked <b>P</b> (and super admins) can post into it. A year with no access set is open to everyone.
        Dates outside every year are not controlled. <b>V</b> (view) is recorded but not enforced yet.
      </div>

      {/* ── Fiscal Years panel ────────────────────────────────────── */}
      <div style={{ marginBottom: 28 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--text-primary)' }}>Fiscal Years</span>
          <Btn onClick={openCreateYear}>+ Add Year</Btn>
        </div>

        {years.length === 0
          ? <div style={{ textAlign: 'center', padding: '28px 16px', color: 'var(--text-muted)', fontSize: 13,
              border: '1.5px dashed var(--border)', borderRadius: 12 }}>
              No fiscal years defined. Click <strong>+ Add Year</strong> to start.
            </div>
          : <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
              {years.map(fy => {
                const st = YEAR_STATUS[yearStatus(fy)];
                return (
                  <div key={fy.id} style={{
                    border: `1.5px solid ${st.color}40`, borderRadius: 12, padding: '12px 16px',
                    background: st.bg, minWidth: 180, display: 'flex', flexDirection: 'column', gap: 6,
                  }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span style={{ fontSize: 20, fontWeight: 900, color: 'var(--text-primary)' }}>{fy.year}</span>
                      <span style={{ fontSize: 10.5, fontWeight: 700, color: st.color, background: `${st.color}22`,
                        borderRadius: 6, padding: '2px 8px' }}>{st.label}</span>
                    </div>
                    <div style={{ fontSize: 11.5, color: 'var(--text-secondary)' }}>{fy.label}</div>
                    {(() => {
                      const managed = Object.keys(accessMap).some(k => k.endsWith(`:${fy.id}`));
                      return (
                        <div title={managed ? 'Only users ticked P (and super admins) can post into this year' : 'No year access set yet, so anyone can post into it'}
                             style={{ fontSize: 10.5, fontWeight: 700, color: managed ? '#1d4ed8' : 'var(--text-muted)' }}>
                          {managed ? '🔒 Post: ticked users only' : '🌐 Post: open to everyone'}
                        </div>
                      );
                    })()}
                    {(fy.start_date || fy.end_date) && (
                      <div style={{ fontSize: 10.5, color: 'var(--text-muted)' }}>
                        {fy.start_date || '?'} → {fy.end_date || '?'}
                      </div>
                    )}
                    <div style={{ display: 'flex', gap: 6, marginTop: 4, flexWrap: 'wrap' }}>
                      <button
                        onClick={() => quickToggle(fy, 'is_locked')}
                        disabled={fy.is_closed}
                        style={{ fontSize: 10.5, padding: '3px 8px', borderRadius: 6, cursor: fy.is_closed ? 'default' : 'pointer',
                          border: '1px solid #000', background: fy.is_locked ? '#fef3c7' : 'var(--bg-surface)',
                          color: fy.is_locked ? '#92400e' : 'var(--text-secondary)', fontWeight: 600 }}>
                        {fy.is_locked ? 'Unlock' : 'Lock'}
                      </button>
                      <button
                        onClick={() => quickToggle(fy, 'is_closed')}
                        style={{ fontSize: 10.5, padding: '3px 8px', borderRadius: 6, cursor: 'pointer',
                          border: '1px solid #000', background: fy.is_closed ? '#fee2e2' : 'var(--bg-surface)',
                          color: fy.is_closed ? '#b91c1c' : 'var(--text-secondary)', fontWeight: 600 }}>
                        {fy.is_closed ? 'Reopen' : 'Close'}
                      </button>
                      <button onClick={() => openEditYear(fy)}
                        style={{ fontSize: 10.5, padding: '3px 8px', borderRadius: 6, cursor: 'pointer',
                          border: '1px solid #000', background: 'var(--bg-surface)', color: 'var(--text-secondary)' }}>
                        Edit
                      </button>
                      <button onClick={() => deleteYear(fy)}
                        style={{ fontSize: 10.5, padding: '3px 8px', borderRadius: 6, cursor: 'pointer',
                          border: '1.5px solid #fca5a5', background: 'var(--bg-surface)', color: '#ef4444' }}>
                        Del
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
        }
      </div>

      {/* ── User × Year matrix ────────────────────────────────────── */}
      {years.length > 0 && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, flexWrap: 'wrap', gap: 8 }}>
            <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--text-primary)' }}>User Year Access</span>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
              <input
                value={userQ} onChange={e => setUserQ(e.target.value)}
                placeholder="Filter users…"
                style={{ padding: '7px 11px', border: '1.5px solid var(--border-strong)', borderRadius: 8,
                  fontSize: 12.5, fontFamily: 'var(--font)', background: 'var(--bg-surface)', color: 'var(--text-primary)', width: 180 }}
              />
              {dirtyCount > 0 && (
                <span style={{ fontSize: 12, background: '#fef3c7', color: '#92400e', border: '1px solid #fbbf24',
                  borderRadius: 8, padding: '5px 11px', fontWeight: 700 }}>
                  {dirtyCount} unsaved change{dirtyCount !== 1 ? 's' : ''}
                </span>
              )}
              <Btn onClick={saveMatrix} loading={savingMatrix} disabled={dirtyCount === 0}>Save Changes</Btn>
            </div>
          </div>

          {/* Legend */}
          <div style={{ display: 'flex', gap: 14, marginBottom: 10, fontSize: 11.5, color: 'var(--text-muted)' }}>
            <span><strong style={{ color: 'var(--text-primary)' }}>V</strong> = Can View</span>
            <span><strong style={{ color: 'var(--accent)' }}>P</strong> = Can Post</span>
            <span style={{ fontSize: 11 }}>— Locked and closed years take no postings · V is not enforced yet</span>
          </div>

          <div style={{ border: '1px solid #000', borderRadius: 14, overflow: 'hidden', background: 'var(--bg-surface)' }}>
            <div style={{ overflowX: 'auto', maxHeight: 'calc(100vh - 440px)' }}>
              <table style={{ borderCollapse: 'collapse', minWidth: 260 + years.length * 120 }}>
                <thead>
                  <tr style={{ background: 'var(--bg-elevated)' }}>
                    <th style={{
                      position: 'sticky', left: 0, zIndex: 3, background: 'var(--bg-elevated)',
                      padding: '11px 16px', textAlign: 'left', borderBottom: '2px solid var(--border)',
                      borderRight: '2px solid var(--border)', fontSize: 11.5, fontWeight: 700,
                      color: 'var(--text-secondary)', textTransform: 'uppercase', letterSpacing: '0.05em',
                      minWidth: 220,
                    }}>
                      User / Year →
                    </th>
                    {years.map(fy => {
                      const st = YEAR_STATUS[yearStatus(fy)];
                      return (
                        <th key={fy.id} style={{
                          padding: '8px 10px', borderBottom: '2px solid var(--border)',
                          borderRight: '1px solid var(--border-light)', textAlign: 'center', minWidth: 100,
                          background: `${st.color}08`,
                        }}>
                          <div style={{ fontSize: 13, fontWeight: 900, color: 'var(--text-primary)' }}>{fy.year}</div>
                          <div style={{ fontSize: 9.5, color: st.color, fontWeight: 700 }}>{st.label}</div>
                        </th>
                      );
                    })}
                    <th style={{
                      padding: '8px 10px', borderBottom: '2px solid var(--border)',
                      textAlign: 'center', minWidth: 100, background: 'var(--bg-elevated)',
                      fontSize: 10, color: 'var(--text-muted)', fontWeight: 600,
                    }}>
                      Quick Grant
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredUsers.map((u, ui) => (
                    <tr key={u.id} style={{ borderTop: ui > 0 ? '1px solid var(--border-light)' : undefined }}>
                      <td style={{
                        position: 'sticky', left: 0, zIndex: 1, background: 'var(--bg-surface)',
                        borderRight: '2px solid var(--border)', padding: '8px 14px',
                      }}>
                        <div style={{ fontSize: 12.5, fontWeight: 600, color: 'var(--text-primary)' }}>
                          {u.first_name} {u.last_name}
                        </div>
                        <div style={{ fontSize: 10.5, color: 'var(--text-muted)' }}>{u.email}</div>
                      </td>
                      {years.map(fy => {
                        const cell = getCell(u.id, fy.id);
                        const key = `${u.id}:${fy.id}`;
                        const isPending = pending[key] !== undefined;
                        const st = yearStatus(fy);
                        return (
                          <td key={fy.id} style={{
                            padding: '7px 8px', borderRight: '1px solid var(--border-light)',
                            textAlign: 'center', verticalAlign: 'middle',
                            background: isPending ? '#fffbeb' : 'transparent',
                          }}>
                            {fy.is_closed
                              ? <span style={{ fontSize: 11, color: '#ef444480' }}>Closed</span>
                              : <div style={{ display: 'flex', flexDirection: 'column', gap: 3, alignItems: 'center' }}>
                                  <label style={{ display: 'flex', alignItems: 'center', gap: 4, cursor: 'pointer', fontSize: 11.5 }}>
                                    <input type="checkbox"
                                      checked={cell?.can_view || false}
                                      onChange={e => setCell(u.id, fy.id, 'can_view', e.target.checked)}
                                      style={{ accentColor: 'var(--accent)', width: 13, height: 13 }} />
                                    <span style={{ color: cell?.can_view ? 'var(--text-primary)' : 'var(--text-muted)' }}>V</span>
                                  </label>
                                  <label style={{ display: 'flex', alignItems: 'center', gap: 4, cursor: st === 'locked' ? 'not-allowed' : 'pointer', fontSize: 11.5 }}>
                                    <input type="checkbox"
                                      checked={cell?.can_post || false}
                                      disabled={st === 'locked'}
                                      onChange={e => setCell(u.id, fy.id, 'can_post', e.target.checked)}
                                      style={{ accentColor: 'var(--accent)', width: 13, height: 13 }} />
                                    <span style={{ color: st === 'locked' ? 'var(--text-muted)' : cell?.can_post ? 'var(--accent)' : 'var(--text-muted)' }}>P</span>
                                  </label>
                                </div>
                            }
                          </td>
                        );
                      })}
                      <td style={{ padding: '6px 8px', textAlign: 'center', verticalAlign: 'middle' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                          <button onClick={() => grantAllYears(u.id)}
                            style={{ fontSize: 10, padding: '3px 7px', borderRadius: 6, cursor: 'pointer',
                              border: '1.5px solid var(--accent)', background: 'var(--accent-dim)',
                              color: 'var(--accent)', fontWeight: 700 }}>
                            Grant All
                          </button>
                          <button onClick={() => revokeAllYears(u.id)}
                            style={{ fontSize: 10, padding: '3px 7px', borderRadius: 6, cursor: 'pointer',
                              border: '1.5px solid #fca5a5', background: 'var(--bg-surface)', color: '#ef4444', fontWeight: 700 }}>
                            Revoke All
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div style={{ padding: '10px 16px', borderTop: '1px solid #000', background: 'var(--bg-elevated)',
              display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>
                {filteredUsers.length} user{filteredUsers.length !== 1 ? 's' : ''} shown. Granting View without Post = read-only access to that year.
              </span>
              <Btn onClick={saveMatrix} loading={savingMatrix} disabled={dirtyCount === 0}>
                {dirtyCount > 0 ? `Save ${dirtyCount} Change${dirtyCount !== 1 ? 's' : ''}` : 'No Changes'}
              </Btn>
            </div>
          </div>
        </div>
      )}

      {/* Year form modal */}
      {yearModal && (
        <Modal onClose={() => setYearModal(null)}>
          <div style={{ padding: '24px 28px', minWidth: 360 }}>
            <div style={{ fontSize: 16, fontWeight: 800, marginBottom: 20, color: 'var(--text-primary)' }}>
              {yearModal.mode === 'create' ? 'Add Fiscal Year' : 'Edit Fiscal Year'}
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
              {[
                { key: 'year', label: 'Year (e.g. 2025)', type: 'number' },
                { key: 'label', label: 'Label (e.g. FY 2025)' },
                { key: 'start_date', label: 'Start Date', type: 'date' },
                { key: 'end_date', label: 'End Date', type: 'date' },
              ].map(f => (
                <div key={f.key}>
                  <div style={{ fontSize: 11.5, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 5 }}>{f.label}</div>
                  <Input type={f.type || 'text'} value={yearForm[f.key] || ''}
                    onChange={e => setYearForm(p => ({ ...p, [f.key]: f.type === 'number' ? parseInt(e.target.value, 10) || '' : e.target.value }))} />
                </div>
              ))}
              <div style={{ display: 'flex', gap: 16 }}>
                {[['is_locked', 'Locked (read-only)'], ['is_closed', 'Closed (no access)']].map(([k, label]) => (
                  <label key={k} style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: 12.5 }}>
                    <input type="checkbox" checked={!!yearForm[k]}
                      onChange={e => setYearForm(p => ({ ...p, [k]: e.target.checked }))}
                      style={{ accentColor: 'var(--accent)' }} />
                    {label}
                  </label>
                ))}
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 22 }}>
              <Btn variant="ghost" onClick={() => setYearModal(null)}>Cancel</Btn>
              <Btn onClick={saveYear} loading={savingYear}>Save</Btn>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}

// ─── ACCESS REQUEST CENTER ────────────────────────────────────────────────────

const REQUEST_TYPES = [
  { value: 'role',        label: 'Role Assignment',      desc: 'Request to be assigned an additional system role.' },
  { value: 'permission',  label: 'Module Permission',    desc: 'Request access to a specific module or action.' },
  { value: 'fiscal_year', label: 'Fiscal Year Access',   desc: 'Request view or posting access to a fiscal year.' },
  { value: 'other',       label: 'Other / Custom',       desc: 'Any other access requirement not covered above.' },
];

const STATUS_STYLE = {
  pending:   { color: '#f59e0b', bg: '#fef3c7', label: 'Pending' },
  approved:  { color: '#10b981', bg: '#d1fae5', label: 'Approved' },
  rejected:  { color: '#ef4444', bg: '#fee2e2', label: 'Rejected' },
  cancelled: { color: '#6b7280', bg: '#f3f4f6', label: 'Cancelled' },
};

function RequestTypeBadge({ type }) {
  const labels = { role: 'Role', permission: 'Permission', fiscal_year: 'Fiscal Year', other: 'Other' };
  const colors = { role: '#3b82f6', permission: '#8b5cf6', fiscal_year: '#f59e0b', other: '#6b7280' };
  const c = colors[type] || '#6b7280';
  return (
    <span style={{ fontSize: 10.5, fontWeight: 700, color: c, background: `${c}18`, borderRadius: 6, padding: '2px 7px' }}>
      {labels[type] || type}
    </span>
  );
}

function timeAgoAR(dateStr) {
  if (!dateStr) return '';
  const diff = Date.now() - new Date(dateStr).getTime();
  const m = Math.floor(diff / 60000);
  if (m < 1) return 'just now';
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  return `${Math.floor(h / 24)}d ago`;
}

function AccessRequestCenter({ toast, user }) {
  const [tab, setTab] = useState('queue');     // queue | my_requests
  const [requests, setRequests] = useState([]);
  const [myRequests, setMyRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  // Roles and fiscal years for the new-request form
  const [roles, setRoles] = useState([]);
  const [fiscalYears, setFiscalYears] = useState([]);

  // New request modal
  const [newModal, setNewModal] = useState(false);
  const [form, setForm] = useState({ request_type: 'role', justification: '' });
  const [submitting, setSubmitting] = useState(false);

  // Review modal (admin)
  const [reviewModal, setReviewModal] = useState(null); // { mode: 'approve'|'reject', request }
  const [reviewNote, setReviewNote] = useState('');
  const [autoProvision, setAutoProvision] = useState(true);
  const [reviewing, setReviewing] = useState(false);

  const isAdmin = (user?.roles || []).some(r => r.role_name === 'super_admin');

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const [all, my, r, fy] = await Promise.all([
        isAdmin ? api.listAccessRequests() : Promise.resolve([]),
        api.listAccessRequests({ my_only: true }),
        api.listRoles(),
        api.listFiscalYears(),
      ]);
      setRequests(Array.isArray(all) ? all : []);
      setMyRequests(Array.isArray(my) ? my : []);
      setRoles(Array.isArray(r) ? r : []);
      setFiscalYears(Array.isArray(fy) ? fy : []);
    } catch {}
    setLoading(false);
  }, [isAdmin]);

  useEffect(() => { load(); }, [load]);

  // ── Submit new request ───────────────────────────────────────────────────

  const buildDetails = () => {
    const t = form.request_type;
    if (t === 'role')        return { role_id: form.role_id, role_name: form.role_name };
    if (t === 'permission')  return { role_id: form.role_id, module: form.module, actions: (form.actions || '').split(',').map(s => s.trim()).filter(Boolean) };
    if (t === 'fiscal_year') return { fiscal_year_id: form.fiscal_year_id, year: form.year, can_post: !!form.can_post };
    return { description: form.other_description || '' };
  };

  const submitRequest = async () => {
    if (!form.request_type) return;
    setSubmitting(true);
    try {
      await api.createAccessRequest({
        request_type: form.request_type,
        details: buildDetails(),
        justification: form.justification,
      });
      toast.show('Request submitted successfully.');
      setNewModal(false);
      setForm({ request_type: 'role', justification: '' });
      load();
    } catch (e) { toast.show(e?.message || 'Submit failed.', 'error'); }
    setSubmitting(false);
  };

  // ── Review actions ───────────────────────────────────────────────────────

  const doReview = async () => {
    if (!reviewModal) return;
    setReviewing(true);
    try {
      if (reviewModal.mode === 'approve') {
        await api.approveAccessRequest(reviewModal.request.id, { review_note: reviewNote, auto_provision: autoProvision });
        toast.show('Request approved' + (autoProvision ? ' and provisioned.' : '.'));
      } else {
        await api.rejectAccessRequest(reviewModal.request.id, { review_note: reviewNote });
        toast.show('Request rejected.');
      }
      setReviewModal(null);
      setReviewNote('');
      load();
    } catch (e) { toast.show(e?.message || 'Action failed.', 'error'); }
    setReviewing(false);
  };

  const doCancel = async (req) => {
    try {
      await api.cancelAccessRequest(req.id);
      toast.show('Request cancelled.');
      load();
    } catch { toast.show('Cancel failed.', 'error'); }
  };

  // ── Renders ──────────────────────────────────────────────────────────────

  const renderDetails = (req) => {
    const d = req.details || {};
    if (req.request_type === 'role')        return `Role: ${d.role_name || d.role_id || '—'}`;
    if (req.request_type === 'permission')  return `Module: ${d.module || '—'} | Actions: ${(d.actions || []).join(', ') || '—'}`;
    if (req.request_type === 'fiscal_year') return `Year: ${d.year || '—'} | ${d.can_post ? 'View + Post' : 'View only'}`;
    return d.description || '—';
  };

  const RequestRow = ({ req, showRequester }) => {
    const st = STATUS_STYLE[req.status] || STATUS_STYLE.pending;
    return (
      <div style={{
        border: '1px solid #000', borderRadius: 12, padding: '14px 18px',
        background: 'var(--bg-surface)', display: 'flex', flexDirection: 'column', gap: 8,
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 8 }}>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
            <RequestTypeBadge type={req.request_type} />
            <span style={{ fontSize: 11, fontWeight: 700, color: st.color, background: st.bg, borderRadius: 6, padding: '2px 8px' }}>
              {st.label}
            </span>
            <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>{timeAgoAR(req.created_at)}</span>
          </div>
          <div style={{ display: 'flex', gap: 6 }}>
            {req.status === 'pending' && isAdmin && (
              <>
                <button
                  onClick={() => { setReviewModal({ mode: 'approve', request: req }); setReviewNote(''); setAutoProvision(true); }}
                  style={{ fontSize: 11, padding: '4px 10px', borderRadius: 7, cursor: 'pointer', border: '1.5px solid #10b981', background: '#d1fae5', color: '#065f46', fontWeight: 700 }}>
                  Approve
                </button>
                <button
                  onClick={() => { setReviewModal({ mode: 'reject', request: req }); setReviewNote(''); }}
                  style={{ fontSize: 11, padding: '4px 10px', borderRadius: 7, cursor: 'pointer', border: '1.5px solid #fca5a5', background: '#fee2e2', color: '#b91c1c', fontWeight: 700 }}>
                  Reject
                </button>
              </>
            )}
            {req.status === 'pending' && (req.requester_id === user?.id || isAdmin) && (
              <button onClick={() => doCancel(req)}
                style={{ fontSize: 11, padding: '4px 10px', borderRadius: 7, cursor: 'pointer', border: '1px solid #000', background: 'var(--bg-surface)', color: 'var(--text-secondary)' }}>
                Cancel
              </button>
            )}
          </div>
        </div>

        {showRequester && req.requester_name && (
          <div style={{ fontSize: 12, color: 'var(--text-secondary)' }}>
            <strong>Requester:</strong> {req.requester_name} ({req.requester_email})
          </div>
        )}

        <div style={{ fontSize: 12.5, color: 'var(--text-primary)', fontWeight: 500 }}>
          {renderDetails(req)}
        </div>

        {req.justification && (
          <div style={{ fontSize: 11.5, color: 'var(--text-secondary)', fontStyle: 'italic', borderLeft: '3px solid var(--border-strong)', paddingLeft: 10 }}>
            "{req.justification}"
          </div>
        )}

        {(req.status === 'approved' || req.status === 'rejected') && (
          <div style={{ fontSize: 11, color: 'var(--text-muted)', borderTop: '1px solid var(--border-light)', paddingTop: 8, marginTop: 2 }}>
            <strong style={{ color: STATUS_STYLE[req.status]?.color }}>{req.status === 'approved' ? '✓ Approved' : '✗ Rejected'}</strong>
            {req.reviewer_name && ` by ${req.reviewer_name}`}
            {req.reviewed_at && ` · ${timeAgoAR(req.reviewed_at)}`}
            {req.review_note && <span style={{ display: 'block', marginTop: 4, fontStyle: 'italic' }}>Note: {req.review_note}</span>}
          </div>
        )}
      </div>
    );
  };

  const pendingQueue = requests.filter(r => r.status === 'pending');

  if (loading) return <SectionLoader />;

  return (
    <div className="fade-in">
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20, flexWrap: 'wrap', gap: 12 }}>
        <div>
          <div style={{ fontSize: 18, fontWeight: 800, color: 'var(--text-primary)' }}>Access Request Center</div>
          <div style={{ fontSize: 12.5, color: 'var(--text-secondary)', marginTop: 3 }}>
            Submit requests for additional access. Admins review and auto-provision on approval.
          </div>
        </div>
        <Btn onClick={() => { setForm({ request_type: 'role', justification: '' }); setNewModal(true); }}>
          + New Request
        </Btn>
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: 0, marginBottom: 20, borderBottom: '2px solid var(--border)' }}>
        {[
          ...(isAdmin ? [{ id: 'queue', label: `Pending Queue`, count: pendingQueue.length }] : []),
          ...(isAdmin ? [{ id: 'all', label: 'All Requests', count: requests.length }] : []),
          { id: 'my_requests', label: 'My Requests', count: myRequests.length },
        ].map(t => (
          <button key={t.id} onClick={() => setTab(t.id)} style={{
            padding: '9px 16px', border: 'none', cursor: 'pointer', fontFamily: 'var(--font)', fontSize: 12.5, fontWeight: 600,
            borderBottom: tab === t.id ? '2px solid var(--accent)' : '2px solid transparent',
            marginBottom: -2, background: 'none',
            color: tab === t.id ? 'var(--accent)' : 'var(--text-secondary)',
          }}>
            {t.label}
            {t.count > 0 && (
              <span style={{ marginLeft: 6, fontSize: 10.5, fontWeight: 700, background: tab === t.id ? 'var(--accent)' : 'var(--border-strong)',
                color: tab === t.id ? '#fff' : 'var(--text-secondary)', borderRadius: 999, padding: '1px 6px' }}>
                {t.count}
              </span>
            )}
          </button>
        ))}
      </div>

      {/* Content */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {tab === 'queue' && isAdmin && (
          pendingQueue.length === 0
            ? <div style={{ textAlign: 'center', padding: '40px 16px', color: 'var(--text-muted)', fontSize: 13 }}>
                No pending requests. All clear.
              </div>
            : pendingQueue.map(r => <RequestRow key={r.id} req={r} showRequester />)
        )}
        {tab === 'all' && isAdmin && (
          requests.length === 0
            ? <div style={{ textAlign: 'center', padding: '40px 16px', color: 'var(--text-muted)', fontSize: 13 }}>No requests yet.</div>
            : requests.map(r => <RequestRow key={r.id} req={r} showRequester />)
        )}
        {tab === 'my_requests' && (
          myRequests.length === 0
            ? <div style={{ textAlign: 'center', padding: '40px 16px', color: 'var(--text-muted)', fontSize: 13 }}>
                You haven't submitted any access requests yet.
              </div>
            : myRequests.map(r => <RequestRow key={r.id} req={r} showRequester={false} />)
        )}
      </div>

      {/* ── New Request Modal ───────────────────────────────────────── */}
      {newModal && (
        <Modal onClose={() => setNewModal(false)}>
          <div style={{ padding: '24px 28px', minWidth: 420, maxWidth: 520 }}>
            <div style={{ fontSize: 16, fontWeight: 800, marginBottom: 20, color: 'var(--text-primary)' }}>New Access Request</div>

            {/* Request type */}
            <div style={{ marginBottom: 16 }}>
              <div style={{ fontSize: 11.5, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 8 }}>Request Type *</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                {REQUEST_TYPES.map(rt => (
                  <label key={rt.value} style={{ display: 'flex', alignItems: 'flex-start', gap: 8, cursor: 'pointer',
                    border: `1.5px solid ${form.request_type === rt.value ? 'var(--accent)' : 'var(--border)'}`,
                    borderRadius: 8, padding: '8px 10px', background: form.request_type === rt.value ? 'var(--accent-dim)' : 'var(--bg-surface)' }}>
                    <input type="radio" name="req_type" value={rt.value} checked={form.request_type === rt.value}
                      onChange={() => setForm(p => ({ ...p, request_type: rt.value }))}
                      style={{ marginTop: 2, accentColor: 'var(--accent)' }} />
                    <div>
                      <div style={{ fontSize: 12.5, fontWeight: 600, color: 'var(--text-primary)' }}>{rt.label}</div>
                      <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>{rt.desc}</div>
                    </div>
                  </label>
                ))}
              </div>
            </div>

            {/* Type-specific fields */}
            {form.request_type === 'role' && (
              <div style={{ marginBottom: 14 }}>
                <div style={{ fontSize: 11.5, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 5 }}>Select Role *</div>
                <select value={form.role_id || ''} onChange={e => {
                  const r = roles.find(x => x.role_id === e.target.value);
                  setForm(p => ({ ...p, role_id: e.target.value, role_name: r?.display_name || '' }));
                }} style={{ width: '100%', padding: '8px 10px', border: '1px solid #000', borderRadius: 8,
                  fontSize: 12.5, fontFamily: 'var(--font)', background: 'var(--bg-surface)', color: 'var(--text-primary)' }}>
                  <option value="">— select —</option>
                  {roles.filter(r => isAdmin || r.role_name !== 'super_admin').map(r => <option key={r.role_id} value={r.role_id}>{r.display_name} ({r.role_name})</option>)}
                </select>
              </div>
            )}

            {form.request_type === 'permission' && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 14 }}>
                <div>
                  <div style={{ fontSize: 11.5, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 5 }}>Role to update *</div>
                  <select value={form.role_id || ''} onChange={e => setForm(p => ({ ...p, role_id: e.target.value }))}
                    style={{ width: '100%', padding: '8px 10px', border: '1px solid #000', borderRadius: 8,
                      fontSize: 12.5, fontFamily: 'var(--font)', background: 'var(--bg-surface)', color: 'var(--text-primary)' }}>
                    <option value="">— select —</option>
                    {roles.map(r => <option key={r.role_id} value={r.role_id}>{r.display_name}</option>)}
                  </select>
                </div>
                <div>
                  <div style={{ fontSize: 11.5, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 5 }}>Module *</div>
                  <Input value={form.module || ''} onChange={e => setForm(p => ({ ...p, module: e.target.value }))} placeholder="e.g. enterprise_requisition" />
                </div>
                <div>
                  <div style={{ fontSize: 11.5, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 5 }}>Actions (comma-separated) *</div>
                  <Input value={form.actions || ''} onChange={e => setForm(p => ({ ...p, actions: e.target.value }))} placeholder="e.g. view, approve" />
                </div>
              </div>
            )}

            {form.request_type === 'fiscal_year' && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 14 }}>
                <div>
                  <div style={{ fontSize: 11.5, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 5 }}>Fiscal Year *</div>
                  <select value={form.fiscal_year_id || ''} onChange={e => {
                    const fy = fiscalYears.find(y => y.id === e.target.value);
                    setForm(p => ({ ...p, fiscal_year_id: e.target.value, year: fy?.year }));
                  }} style={{ width: '100%', padding: '8px 10px', border: '1px solid #000', borderRadius: 8,
                    fontSize: 12.5, fontFamily: 'var(--font)', background: 'var(--bg-surface)', color: 'var(--text-primary)' }}>
                    <option value="">— select —</option>
                    {fiscalYears.filter(y => !y.is_closed).map(y => (
                      <option key={y.id} value={y.id}>{y.label}{y.is_locked ? ' (locked — view only)' : ''}</option>
                    ))}
                  </select>
                </div>
                {form.fiscal_year_id && !fiscalYears.find(y => y.id === form.fiscal_year_id)?.is_locked && (
                  <label style={{ display: 'flex', alignItems: 'center', gap: 7, fontSize: 12.5, cursor: 'pointer' }}>
                    <input type="checkbox" checked={!!form.can_post}
                      onChange={e => setForm(p => ({ ...p, can_post: e.target.checked }))}
                      style={{ accentColor: 'var(--accent)' }} />
                    Request posting access (not just view)
                  </label>
                )}
              </div>
            )}

            {form.request_type === 'other' && (
              <div style={{ marginBottom: 14 }}>
                <div style={{ fontSize: 11.5, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 5 }}>Describe what you need *</div>
                <Textarea rows={3} value={form.other_description || ''}
                  onChange={e => setForm(p => ({ ...p, other_description: e.target.value }))}
                  placeholder="Describe the access you need…" />
              </div>
            )}

            {/* Justification */}
            <div style={{ marginBottom: 20 }}>
              <div style={{ fontSize: 11.5, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 5 }}>
                Business Justification
              </div>
              <Textarea rows={2} value={form.justification || ''}
                onChange={e => setForm(p => ({ ...p, justification: e.target.value }))}
                placeholder="Why do you need this access?" />
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
              <Btn variant="ghost" onClick={() => setNewModal(false)}>Cancel</Btn>
              <Btn onClick={submitRequest} loading={submitting}>Submit Request</Btn>
            </div>
          </div>
        </Modal>
      )}

      {/* ── Review Modal ────────────────────────────────────────────── */}
      {reviewModal && (
        <Modal onClose={() => setReviewModal(null)}>
          <div style={{ padding: '24px 28px', minWidth: 400, maxWidth: 480 }}>
            <div style={{ fontSize: 16, fontWeight: 800, marginBottom: 4, color: 'var(--text-primary)' }}>
              {reviewModal.mode === 'approve' ? 'Approve Request' : 'Reject Request'}
            </div>
            <div style={{ fontSize: 12, color: 'var(--text-secondary)', marginBottom: 18 }}>
              {reviewModal.request.requester_name} · {renderDetails(reviewModal.request)}
            </div>

            {reviewModal.mode === 'approve' && (
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', marginBottom: 16, fontSize: 12.5 }}>
                <input type="checkbox" checked={autoProvision}
                  onChange={e => setAutoProvision(e.target.checked)}
                  style={{ accentColor: 'var(--accent)', width: 14, height: 14 }} />
                <div>
                  <div style={{ fontWeight: 600 }}>Auto-provision access</div>
                  <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>Automatically apply the requested access on approval</div>
                </div>
              </label>
            )}

            <div style={{ marginBottom: 20 }}>
              <div style={{ fontSize: 11.5, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 5 }}>
                Review Note {reviewModal.mode === 'reject' ? '*' : '(optional)'}
              </div>
              <Textarea rows={3} value={reviewNote} onChange={e => setReviewNote(e.target.value)}
                placeholder={reviewModal.mode === 'approve' ? 'Optional note for the requester…' : 'Reason for rejection…'} />
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
              <Btn variant="ghost" onClick={() => setReviewModal(null)}>Cancel</Btn>
              <Btn
                onClick={doReview}
                loading={reviewing}
                style={reviewModal.mode === 'reject'
                  ? { background: '#ef4444', color: '#fff', border: 'none' }
                  : undefined}
              >
                {reviewModal.mode === 'approve' ? 'Approve' : 'Reject'}
              </Btn>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}

// ─── PERMISSION AUDIT TRAIL ──────────────────────────────────────────────────

const AUDIT_EVENT_LABELS = {
  access_request_submitted:    { label: 'Request Submitted',    color: '#3b82f6' },
  access_request_approved:     { label: 'Request Approved',     color: '#10b981' },
  access_request_rejected:     { label: 'Request Rejected',     color: '#ef4444' },
  access_request_cancelled:    { label: 'Request Cancelled',    color: '#6b7280' },
  role_assigned:               { label: 'Role Assigned',        color: '#8b5cf6' },
  role_removed:                { label: 'Role Removed',         color: '#f59e0b' },
  permissions_updated:         { label: 'Permissions Updated',  color: '#06b6d4' },
  year_access_granted:         { label: 'Year Access Granted',  color: '#10b981' },
  year_access_revoked:         { label: 'Year Access Revoked',  color: '#f59e0b' },
  fiscal_year_created:         { label: 'Fiscal Year Created',  color: '#3b82f6' },
  fiscal_year_locked:          { label: 'Year Locked',          color: '#f59e0b' },
  fiscal_year_closed:          { label: 'Year Closed',          color: '#ef4444' },
  fiscal_year_reopened:        { label: 'Year Reopened',        color: '#10b981' },
  org_hierarchy_changed:       { label: 'Org Changed',          color: '#6b7280' },
  approval_limit_updated:      { label: 'Limit Updated',        color: '#8b5cf6' },
  modification_access_updated: { label: 'Mod Access Updated',   color: '#06b6d4' },
  user_created:                { label: 'User Created',         color: '#3b82f6' },
  user_updated:                { label: 'User Updated',         color: '#64748b' },
  user_activated:              { label: 'User Reactivated',     color: '#10b981' },
  user_deactivated:            { label: 'User Deactivated',     color: '#f59e0b' },
  user_deleted:                { label: 'User Deleted',         color: '#b91c1c' },
  departments_changed:         { label: 'Departments Changed',  color: '#0ea5e9' },
  email_changed:               { label: 'Email Changed',        color: '#0ea5e9' },
  account_locked:              { label: 'Account Locked',       color: '#ef4444' },
  account_unlocked:            { label: 'Account Unlocked',     color: '#10b981' },
  password_reset:              { label: 'Password Reset',       color: '#f59e0b' },
  impersonation_started:       { label: 'Sign-in As Started',   color: '#7c3aed' },
  impersonation_ended:         { label: 'Sign-in As Ended',     color: '#7c3aed' },
  role_created:                { label: 'Role Created',         color: '#8b5cf6' },
  role_updated:                { label: 'Role Updated',         color: '#8b5cf6' },
  fiscal_year_unlocked:        { label: 'Year Unlocked',        color: '#10b981' },
  fiscal_year_updated:         { label: 'Fiscal Year Updated',  color: '#3b82f6' },
  fiscal_year_deleted:         { label: 'Fiscal Year Deleted',  color: '#ef4444' },
  workflow_updated:            { label: 'Workflow Changed',     color: '#0d9488' },
  mfa_required:                { label: 'MFA Required',         color: '#7c3aed' },
  mfa_not_required:            { label: 'MFA Not Required',     color: '#64748b' },
  mfa_enrolled:                { label: 'MFA Set Up',           color: '#10b981' },
  mfa_reset:                   { label: 'MFA Reset',            color: '#f59e0b' },
};

function AuditEventChip({ eventType }) {
  const cfg = AUDIT_EVENT_LABELS[eventType] || { label: eventType, color: '#6b7280' };
  return (
    <span style={{ fontSize: 10.5, fontWeight: 700, color: cfg.color,
      background: `${cfg.color}18`, borderRadius: 6, padding: '2px 8px', whiteSpace: 'nowrap' }}>
      {cfg.label}
    </span>
  );
}

function PermissionAuditTrail({ toast }) {
  const [logs, setLogs] = useState([]);
  const [stats, setStats] = useState(null);
  const [eventTypes, setEventTypes] = useState([]);
  const [loading, setLoading] = useState(true);

  // Filters
  const [filters, setFilters] = useState({ event_type: '', start_date: '', end_date: '' });
  const [applied, setApplied] = useState({});
  const [page, setPage] = useState(0);
  const PAGE = 50;

  const load = useCallback(async (f = {}, skip = 0) => {
    setLoading(true);
    try {
      const params = { skip, limit: PAGE };
      if (f.event_type) params.event_type = f.event_type;
      if (f.start_date) params.start_date = f.start_date;
      if (f.end_date)   params.end_date   = f.end_date;
      const [l, s, et] = await Promise.all([
        api.listAuditLog(params),
        stats ? Promise.resolve(stats) : api.getAuditStats(),
        eventTypes.length ? Promise.resolve({ event_types: eventTypes }) : api.getAuditEventTypes(),
      ]);
      setLogs(Array.isArray(l) ? l : []);
      if (s) setStats(s);
      if (et?.event_types) setEventTypes(et.event_types);
    } catch {}
    setLoading(false);
  }, [stats, eventTypes]);

  useEffect(() => { load({}, 0); }, []); // eslint-disable-line

  const applyFilters = () => {
    setApplied({ ...filters });
    setPage(0);
    load(filters, 0);
  };

  const clearFilters = () => {
    const f = { event_type: '', start_date: '', end_date: '' };
    setFilters(f);
    setApplied({});
    setPage(0);
    load(f, 0);
  };

  const goPage = (n) => {
    setPage(n);
    load(applied, n * PAGE);
  };

  const hasFilters = Object.values(applied).some(Boolean);

  return (
    <div className="fade-in">
      <div style={{ fontSize: 18, fontWeight: 800, color: 'var(--text-primary)', marginBottom: 4 }}>Permission Audit Trail</div>
      <div style={{ fontSize: 12.5, color: 'var(--text-secondary)', marginBottom: 20 }}>
        Tamper-evident log of every access-control change. New events are written automatically.
      </div>

      {/* Stats row */}
      {stats && (
        <div style={{ display: 'flex', gap: 12, marginBottom: 20, flexWrap: 'wrap' }}>
          {[
            { label: 'Total Events', value: stats.total_events },
            { label: 'Last 30 Days', value: stats.last_30_days },
            { label: 'Event Types', value: (stats.by_event_type || []).length },
          ].map(s => (
            <div key={s.label} style={{ background: 'var(--bg-elevated)', border: '1px solid #000',
              borderRadius: 12, padding: '12px 20px', minWidth: 140 }}>
              <div style={{ fontSize: 22, fontWeight: 900, color: 'var(--text-primary)' }}>{s.value}</div>
              <div style={{ fontSize: 11.5, color: 'var(--text-muted)' }}>{s.label}</div>
            </div>
          ))}
          {/* Top event types */}
          <div style={{ flex: 1, background: 'var(--bg-elevated)', border: '1px solid #000',
            borderRadius: 12, padding: '12px 16px', minWidth: 240 }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--text-secondary)', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Top Event Types</div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
              {(stats.by_event_type || []).slice(0, 6).map(e => (
                <span key={e.event_type} style={{ fontSize: 11, background: 'var(--bg-surface)',
                  border: '1px solid var(--border)', borderRadius: 6, padding: '2px 8px', color: 'var(--text-secondary)' }}>
                  {AUDIT_EVENT_LABELS[e.event_type]?.label || e.event_type} <strong>{e.count}</strong>
                </span>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Filters */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap', alignItems: 'flex-end' }}>
        <div>
          <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 4 }}>Event Type</div>
          <select value={filters.event_type} onChange={e => setFilters(p => ({ ...p, event_type: e.target.value }))}
            style={{ padding: '7px 10px', border: '1px solid #000', borderRadius: 8,
              fontSize: 12, fontFamily: 'var(--font)', background: 'var(--bg-surface)', color: 'var(--text-primary)', minWidth: 180 }}>
            <option value="">All types</option>
            {eventTypes.map(et => (
              <option key={et} value={et}>{AUDIT_EVENT_LABELS[et]?.label || et}</option>
            ))}
          </select>
        </div>
        <div>
          <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 4 }}>From</div>
          <input type="date" value={filters.start_date} onChange={e => setFilters(p => ({ ...p, start_date: e.target.value }))}
            style={{ padding: '7px 10px', border: '1px solid #000', borderRadius: 8,
              fontSize: 12, fontFamily: 'var(--font)', background: 'var(--bg-surface)', color: 'var(--text-primary)' }} />
        </div>
        <div>
          <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 4 }}>To</div>
          <input type="date" value={filters.end_date} onChange={e => setFilters(p => ({ ...p, end_date: e.target.value }))}
            style={{ padding: '7px 10px', border: '1px solid #000', borderRadius: 8,
              fontSize: 12, fontFamily: 'var(--font)', background: 'var(--bg-surface)', color: 'var(--text-primary)' }} />
        </div>
        <Btn onClick={applyFilters}>Apply</Btn>
        {hasFilters && <Btn variant="ghost" onClick={clearFilters}>Clear</Btn>}
      </div>

      {/* Log table */}
      <div style={{ border: '1px solid #000', borderRadius: 14, overflow: 'hidden', background: 'var(--bg-surface)' }}>
        {loading
          ? <SectionLoader />
          : logs.length === 0
            ? <div style={{ textAlign: 'center', padding: '40px 16px', color: 'var(--text-muted)', fontSize: 13 }}>
                No audit events found{hasFilters ? ' for the selected filters.' : '. Events will appear here as access changes are made.'}
              </div>
            : <div style={{ overflowX: 'auto' }}>
                {(() => {
                  const thS = { padding: '11px 14px', fontWeight: 700, fontSize: 12, color: '#fff', textTransform: 'uppercase', letterSpacing: '0.06em', whiteSpace: 'nowrap', textAlign: 'left', border: '1px solid rgba(255,255,255,0.2)', background: '#0b318bff' };
                  const tdS = { padding: '10px 14px', fontSize: 12.5, border: '1px solid #e2e8f0', verticalAlign: 'middle' };
                  return (
                <table style={{ borderCollapse: 'collapse', width: '100%', minWidth: 700 }}>
                  <thead>
                    <tr style={{ background: '#0b318bff', color: '#fff' }}>
                      {['When', 'Event', 'Actor', 'Affected User', 'Description'].map(h => (
                        <th key={h} style={thS}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {logs.map((log, i) => (
                      <tr key={log.id}
                        style={{ background: i % 2 === 0 ? '#fff' : '#f8fafc' }}
                        onMouseEnter={e => e.currentTarget.style.background = '#eff6ff'}
                        onMouseLeave={e => e.currentTarget.style.background = i % 2 === 0 ? '#fff' : '#f8fafc'}>
                        <td style={{ ...tdS, fontSize: 11.5, color: '#64748b', whiteSpace: 'nowrap' }}>
                          {new Date(log.created_at).toLocaleString()}
                        </td>
                        <td style={tdS}>
                          <AuditEventChip eventType={log.event_type} />
                        </td>
                        <td style={tdS}>
                          {log.actor_name
                            ? <><div style={{ fontWeight: 600, color: '#0f172a' }}>{log.actor_name}</div>
                                <div style={{ fontSize: 10.5, color: '#94a3b8' }}>{log.actor_email}</div></>
                            : <span style={{ color: '#94a3b8' }}>System</span>}
                        </td>
                        <td style={tdS}>
                          {log.target_user_name
                            ? <><div style={{ fontWeight: 500, color: '#0f172a' }}>{log.target_user_name}</div>
                                <div style={{ fontSize: 10.5, color: '#94a3b8' }}>{log.target_user_email}</div></>
                            : <span style={{ color: '#94a3b8' }}>—</span>}
                        </td>
                        <td style={{ ...tdS, color: '#0f172a', maxWidth: 320 }}>
                          {log.description}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                  );
                })()}
              </div>
        }

        {/* Pagination */}
        {!loading && logs.length > 0 && (
          <div style={{ borderTop: '1px solid #e2e8f0' }}>
            <Pagination
              total={page * PAGE + logs.length + (logs.length === PAGE ? 1 : 0)}
              skip={page * PAGE}
              limit={PAGE}
              onChange={({ skip, limit }) => goPage(Math.floor(skip / limit))}
            />
          </div>
        )}
      </div>
    </div>
  );
}

// ─── ACCESS REPORT CENTER ─────────────────────────────────────────────────────

function AccessReportCenter({ toast }) {
  const [summary, setSummary] = useState(null);
  const [inventory, setInventory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeReport, setActiveReport] = useState('overview');
  const [inventoryQ, setInventoryQ] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const s = await api.getAccessReportSummary();
      setSummary(s);
    } catch {}
    setLoading(false);
  }, []);

  useEffect(() => { load(); }, [load]);

  const loadInventory = useCallback(async () => {
    if (inventory.length > 0) return;
    try {
      const inv = await api.getUserAccessInventory();
      setInventory(Array.isArray(inv) ? inv : []);
    } catch {}
  }, [inventory.length]);

  useEffect(() => {
    if (activeReport === 'inventory') loadInventory();
  }, [activeReport, loadInventory]);

  const exportJSON = (data, filename) => {
    const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a'); a.href = url; a.download = filename; a.click();
    URL.revokeObjectURL(url);
  };

  const exportCSVData = (rows, filename) => {
    if (!rows.length) return;
    const keys = Object.keys(rows[0]);
    const csv = [keys.join(','), ...rows.map(r => keys.map(k => JSON.stringify(r[k] ?? '')).join(','))].join('\n');
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a'); a.href = url; a.download = filename; a.click();
    URL.revokeObjectURL(url);
  };

  const REPORTS = [
    { id: 'overview',    label: 'Overview' },
    { id: 'roles',       label: 'Role Distribution' },
    { id: 'dormant',     label: 'Dormant Accounts' },
    { id: 'high_risk',   label: 'High Risk Users' },
    { id: 'requests',    label: 'Request Statistics' },
    { id: 'years',       label: 'Year Access' },
    { id: 'inventory',   label: 'Access Inventory' },
  ];

  if (loading || !summary) return <SectionLoader />;

  const { total_users, dormant_users, high_risk_users, user_role_distribution,
          users_without_role, access_request_stats, year_access_summary } = summary;

  const filteredInventory = inventory.filter(u => {
    if (!inventoryQ.trim()) return true;
    const q = inventoryQ.toLowerCase();
    return [u.email, u.name].some(v => (v || '').toLowerCase().includes(q));
  });

  const renderReport = () => {
    switch (activeReport) {
      case 'overview':
        return (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
              {[
                { label: 'Total Users', value: total_users, color: '#3b82f6' },
                { label: 'Dormant Accounts', value: dormant_users.length, color: '#f59e0b' },
                { label: 'High/Critical Risk', value: high_risk_users.length, color: '#ef4444' },
                { label: 'No Role Assigned', value: users_without_role.length, color: '#8b5cf6' },
                { label: 'Pending Requests', value: access_request_stats.pending, color: '#06b6d4' },
              ].map(s => (
                <div key={s.label} style={{ background: 'var(--bg-elevated)', border: `1.5px solid ${s.color}30`,
                  borderLeft: `4px solid ${s.color}`, borderRadius: 12, padding: '16px 20px', minWidth: 160 }}>
                  <div style={{ fontSize: 28, fontWeight: 900, color: s.color }}>{s.value}</div>
                  <div style={{ fontSize: 12, color: 'var(--text-secondary)', marginTop: 2 }}>{s.label}</div>
                </div>
              ))}
            </div>
            <div style={{ fontSize: 13, color: 'var(--text-secondary)', fontStyle: 'italic' }}>
              Select a report from the left to drill into details and export data.
            </div>
          </div>
        );

      case 'roles':
        return (
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 14 }}>
              <span style={{ fontSize: 14, fontWeight: 700 }}>Role Distribution ({user_role_distribution.length} roles)</span>
              <Btn variant="ghost" onClick={() => exportCSVData(user_role_distribution, 'role-distribution.csv')}>Export CSV</Btn>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {user_role_distribution.map(r => {
                const pct = total_users > 0 ? (r.user_count / total_users) * 100 : 0;
                return (
                  <div key={r.role_id} style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <div style={{ fontSize: 12.5, fontWeight: 600, color: 'var(--text-primary)', minWidth: 180 }}>{r.display_name}</div>
                    <div style={{ flex: 1, height: 10, background: 'var(--bg-elevated)', borderRadius: 999, overflow: 'hidden' }}>
                      <div style={{ height: '100%', width: `${pct}%`, background: 'var(--accent)', borderRadius: 999, transition: 'width 0.4s' }} />
                    </div>
                    <span style={{ fontSize: 12, color: 'var(--text-secondary)', minWidth: 60, textAlign: 'right' }}>
                      {r.user_count} user{r.user_count !== 1 ? 's' : ''}
                    </span>
                  </div>
                );
              })}
              {users_without_role.length > 0 && (
                <div style={{ marginTop: 12, padding: '10px 14px', background: '#fef3c7', borderRadius: 8, fontSize: 12.5, color: '#92400e' }}>
                  ⚠ {users_without_role.length} active user{users_without_role.length !== 1 ? 's' : ''} have no role assigned.
                </div>
              )}
            </div>
          </div>
        );

      case 'dormant': {
        const thS = { padding: '11px 14px', fontWeight: 700, fontSize: 12, color: '#fff', textTransform: 'uppercase', letterSpacing: '0.06em', whiteSpace: 'nowrap', textAlign: 'left', border: '1px solid rgba(255,255,255,0.2)', background: '#0b318bff' };
        const tdS = { padding: '10px 14px', fontSize: 12.5, border: '1px solid #e2e8f0', verticalAlign: 'middle' };
        return (
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 14 }}>
              <span style={{ fontSize: 14, fontWeight: 700 }}>Dormant Accounts — no login in 30+ days ({dormant_users.length})</span>
              <Btn variant="ghost" onClick={() => exportCSVData(dormant_users, 'dormant-users.csv')}>Export CSV</Btn>
            </div>
            {dormant_users.length === 0
              ? <div style={{ color: 'var(--text-muted)', textAlign: 'center', padding: 32 }}>No dormant accounts. All users are active.</div>
              : <div style={{ border: '1px solid #000', borderRadius: 14, overflow: 'hidden' }}>
                  <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <thead><tr style={{ background: '#0b318bff', color: '#fff' }}>
                      {['Name', 'Email', 'Last Login'].map(h => <th key={h} style={thS}>{h}</th>)}
                    </tr></thead>
                    <tbody>{dormant_users.map((u, i) => (
                      <tr key={u.id}
                        style={{ background: i % 2 === 0 ? '#fff' : '#f8fafc' }}
                        onMouseEnter={e => e.currentTarget.style.background = '#eff6ff'}
                        onMouseLeave={e => e.currentTarget.style.background = i % 2 === 0 ? '#fff' : '#f8fafc'}>
                        <td style={{ ...tdS, fontWeight: 600, color: '#0f172a' }}>{u.name}</td>
                        <td style={{ ...tdS, color: '#475569' }}>{u.email}</td>
                        <td style={{ ...tdS, color: '#f59e0b', fontWeight: 600 }}>
                          {u.last_login_at ? new Date(u.last_login_at).toLocaleDateString() : 'Never logged in'}
                        </td>
                      </tr>
                    ))}</tbody>
                  </table>
                </div>
            }
          </div>
        );
      }

      case 'high_risk': {
        const thS = { padding: '11px 14px', fontWeight: 700, fontSize: 12, color: '#fff', textTransform: 'uppercase', letterSpacing: '0.06em', whiteSpace: 'nowrap', textAlign: 'left', border: '1px solid rgba(255,255,255,0.2)', background: '#0b318bff' };
        const tdS = { padding: '10px 14px', fontSize: 12.5, border: '1px solid #e2e8f0', verticalAlign: 'middle' };
        return (
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 14 }}>
              <span style={{ fontSize: 14, fontWeight: 700 }}>High / Critical Risk Users ({high_risk_users.length})</span>
              <Btn variant="ghost" onClick={() => exportCSVData(high_risk_users, 'high-risk-users.csv')}>Export CSV</Btn>
            </div>
            {high_risk_users.length === 0
              ? <div style={{ color: 'var(--text-muted)', textAlign: 'center', padding: 32 }}>No high or critical risk users.</div>
              : <div style={{ border: '1px solid #000', borderRadius: 14, overflow: 'hidden' }}>
                  <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <thead><tr style={{ background: '#0b318bff', color: '#fff' }}>
                      {['Name', 'Email', 'Risk', 'Locked', 'MFA'].map(h => <th key={h} style={thS}>{h}</th>)}
                    </tr></thead>
                    <tbody>{high_risk_users.map((u, i) => (
                      <tr key={u.id}
                        style={{ background: i % 2 === 0 ? '#fff' : '#f8fafc' }}
                        onMouseEnter={e => e.currentTarget.style.background = '#eff6ff'}
                        onMouseLeave={e => e.currentTarget.style.background = i % 2 === 0 ? '#fff' : '#f8fafc'}>
                        <td style={{ ...tdS, fontWeight: 600, color: '#0f172a' }}>{u.name}</td>
                        <td style={{ ...tdS, color: '#475569' }}>{u.email}</td>
                        <td style={tdS}>
                          <span style={{ fontSize: 11, fontWeight: 700, color: u.risk_level === 'Critical' ? '#ef4444' : '#f59e0b',
                            background: u.risk_level === 'Critical' ? '#fee2e2' : '#fef3c7', borderRadius: 6, padding: '2px 8px' }}>
                            {u.risk_level}
                          </span>
                        </td>
                        <td style={{ ...tdS, fontWeight: 600, color: u.is_locked ? '#ef4444' : '#10b981' }}>
                          {u.is_locked ? 'Yes' : 'No'}
                        </td>
                        <td style={{ ...tdS, fontWeight: 600, color: u.mfa_enabled ? '#10b981' : '#f59e0b' }}>
                          {u.mfa_enabled ? '✓ Enabled' : '✗ Disabled'}
                        </td>
                      </tr>
                    ))}</tbody>
                  </table>
                </div>
            }
          </div>
        );
      }

      case 'requests': {
        const req = access_request_stats;
        return (
          <div>
            <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 16 }}>Access Request Statistics</div>
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginBottom: 20 }}>
              {[
                { label: 'Total',     value: req.total,     color: '#3b82f6' },
                { label: 'Pending',   value: req.pending,   color: '#f59e0b' },
                { label: 'Approved',  value: req.approved,  color: '#10b981' },
                { label: 'Rejected',  value: req.rejected,  color: '#ef4444' },
                { label: 'Cancelled', value: req.cancelled, color: '#6b7280' },
              ].map(s => (
                <div key={s.label} style={{ background: 'var(--bg-elevated)', border: `1.5px solid ${s.color}30`,
                  borderRadius: 12, padding: '14px 18px', minWidth: 110, textAlign: 'center' }}>
                  <div style={{ fontSize: 24, fontWeight: 900, color: s.color }}>{s.value}</div>
                  <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>{s.label}</div>
                </div>
              ))}
            </div>
            <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 10 }}>By Request Type</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {Object.entries(req.by_type || {}).map(([type, count]) => (
                <div key={type} style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                  <span style={{ fontSize: 12.5, minWidth: 160, color: 'var(--text-primary)', fontWeight: 500 }}>
                    {type.replace('_', ' ').replace(/\b\w/g, c => c.toUpperCase())}
                  </span>
                  <div style={{ flex: 1, height: 10, background: 'var(--bg-elevated)', borderRadius: 999 }}>
                    <div style={{ height: '100%', width: `${req.total > 0 ? (count / req.total) * 100 : 0}%`,
                      background: 'var(--accent)', borderRadius: 999 }} />
                  </div>
                  <span style={{ fontSize: 12, color: 'var(--text-secondary)', minWidth: 40, textAlign: 'right' }}>{count}</span>
                </div>
              ))}
            </div>
          </div>
        );
      }

      case 'years': {
        const thS = { padding: '11px 14px', fontWeight: 700, fontSize: 12, color: '#fff', textTransform: 'uppercase', letterSpacing: '0.06em', whiteSpace: 'nowrap', textAlign: 'left', border: '1px solid rgba(255,255,255,0.2)', background: '#0b318bff' };
        const tdS = { padding: '10px 14px', fontSize: 12.5, border: '1px solid #e2e8f0', verticalAlign: 'middle' };
        return (
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 14 }}>
              <span style={{ fontSize: 14, fontWeight: 700 }}>Fiscal Year Access Summary</span>
              <Btn variant="ghost" onClick={() => exportCSVData(year_access_summary, 'year-access.csv')}>Export CSV</Btn>
            </div>
            {year_access_summary.length === 0
              ? <div style={{ color: 'var(--text-muted)', textAlign: 'center', padding: 32 }}>No fiscal years defined.</div>
              : <div style={{ border: '1px solid #000', borderRadius: 14, overflow: 'hidden' }}>
                  <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <thead><tr style={{ background: '#0b318bff', color: '#fff' }}>
                      {['Year', 'Label', 'Status', 'Can View', 'Can Post'].map(h => <th key={h} style={thS}>{h}</th>)}
                    </tr></thead>
                    <tbody>{year_access_summary.map((y, i) => {
                      const st = y.is_closed ? { l: 'Closed', c: '#ef4444' } : y.is_locked ? { l: 'Locked', c: '#f59e0b' } : { l: 'Open', c: '#10b981' };
                      return (
                        <tr key={y.year}
                          style={{ background: i % 2 === 0 ? '#fff' : '#f8fafc' }}
                          onMouseEnter={e => e.currentTarget.style.background = '#eff6ff'}
                          onMouseLeave={e => e.currentTarget.style.background = i % 2 === 0 ? '#fff' : '#f8fafc'}>
                          <td style={{ ...tdS, fontSize: 16, fontWeight: 900, color: '#0f172a' }}>{y.year}</td>
                          <td style={{ ...tdS, color: '#475569' }}>{y.label}</td>
                          <td style={tdS}>
                            <span style={{ fontSize: 11, fontWeight: 700, color: st.c, background: `${st.c}18`, borderRadius: 6, padding: '2px 8px' }}>{st.l}</span>
                          </td>
                          <td style={{ ...tdS, fontSize: 13, fontWeight: 700, color: '#3b82f6' }}>{y.users_with_view}</td>
                          <td style={{ ...tdS, fontSize: 13, fontWeight: 700, color: '#10b981' }}>{y.users_with_post}</td>
                        </tr>
                      );
                    })}</tbody>
                  </table>
                </div>
            }
          </div>
        );
      }

      case 'inventory':
        return (
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14, flexWrap: 'wrap', gap: 8 }}>
              <span style={{ fontSize: 14, fontWeight: 700 }}>Full Access Inventory ({inventory.length} users)</span>
              <div style={{ display: 'flex', gap: 8 }}>
                <input value={inventoryQ} onChange={e => setInventoryQ(e.target.value)}
                  placeholder="Search…"
                  style={{ padding: '7px 11px', border: '1px solid #000', borderRadius: 8,
                    fontSize: 12, fontFamily: 'var(--font)', background: 'var(--bg-surface)', color: 'var(--text-primary)', width: 160 }} />
                <Btn variant="ghost" onClick={() => exportJSON(inventory, 'access-inventory.json')}>Export JSON</Btn>
              </div>
            </div>
            {inventory.length === 0
              ? <SectionLoader />
              : <div style={{ display: 'flex', flexDirection: 'column', gap: 8, maxHeight: 'calc(100vh - 380px)', overflowY: 'auto' }}>
                  {filteredInventory.map(u => (
                    <div key={u.id} style={{ border: '1px solid #000', borderRadius: 10, padding: '12px 16px',
                      background: 'var(--bg-surface)' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8, marginBottom: 8 }}>
                        <div>
                          <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--text-primary)' }}>{u.name}</span>
                          <span style={{ fontSize: 11.5, color: 'var(--text-muted)', marginLeft: 8 }}>{u.email}</span>
                        </div>
                        <div style={{ display: 'flex', gap: 6 }}>
                          <RiskBadge risk={u.risk_level} />
                          {u.mfa_enabled && <span style={{ fontSize: 10, fontWeight: 700, color: '#10b981', background: '#d1fae5', borderRadius: 6, padding: '2px 7px' }}>MFA</span>}
                          {u.is_locked && <span style={{ fontSize: 10, fontWeight: 700, color: '#ef4444', background: '#fee2e2', borderRadius: 6, padding: '2px 7px' }}>Locked</span>}
                        </div>
                      </div>
                      <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
                        <div>
                          <div style={{ fontSize: 10.5, fontWeight: 600, color: 'var(--text-muted)', marginBottom: 4, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Roles</div>
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                            {u.roles.length === 0
                              ? <span style={{ fontSize: 11, color: '#f59e0b' }}>No roles</span>
                              : u.roles.map(r => (
                                  <span key={r} style={{ fontSize: 11, background: 'var(--bg-elevated)', border: '1px solid var(--border)', borderRadius: 6, padding: '2px 7px', color: 'var(--text-secondary)' }}>{r}</span>
                                ))}
                          </div>
                        </div>
                        {u.year_access.length > 0 && (
                          <div>
                            <div style={{ fontSize: 10.5, fontWeight: 600, color: 'var(--text-muted)', marginBottom: 4, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Year Access</div>
                            <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                              {u.year_access.map(ya => (
                                <span key={ya.year} style={{ fontSize: 11, background: ya.can_post ? '#d1fae5' : '#eff6ff',
                                  color: ya.can_post ? '#065f46' : '#1d4ed8', border: '1px solid currentColor', borderRadius: 6, padding: '2px 7px' }}>
                                  {ya.year}{ya.can_post ? ' (V+P)' : ' (V)'}
                                </span>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
            }
          </div>
        );

      default: return null;
    }
  };

  return (
    <div className="fade-in">
      <div style={{ fontSize: 18, fontWeight: 800, color: 'var(--text-primary)', marginBottom: 4 }}>Access Report Center</div>
      <div style={{ fontSize: 12.5, color: 'var(--text-secondary)', marginBottom: 20 }}>
        Snapshot reports on user access, roles, risk, and fiscal year coverage.
        <button onClick={load} style={{ marginLeft: 12, fontSize: 11.5, color: 'var(--accent)', background: 'none', border: 'none', cursor: 'pointer', textDecoration: 'underline' }}>
          Refresh
        </button>
      </div>

      <div style={{ display: 'flex', gap: 0, marginBottom: 20, borderBottom: '2px solid var(--border)', flexWrap: 'wrap' }}>
        {REPORTS.map(r => (
          <button key={r.id} onClick={() => setActiveReport(r.id)} style={{
            padding: '9px 14px', border: 'none', cursor: 'pointer', fontFamily: 'var(--font)', fontSize: 12, fontWeight: 600,
            borderBottom: activeReport === r.id ? '2px solid var(--accent)' : '2px solid transparent',
            marginBottom: -2, background: 'none',
            color: activeReport === r.id ? 'var(--accent)' : 'var(--text-secondary)',
          }}>
            {r.label}
          </button>
        ))}
      </div>

      {renderReport()}
    </div>
  );
}

// ─── COMING SOON PLACEHOLDER ─────────────────────────────────────────────────

function ComingSoon({ title, phase, description }) {
  return (
    <div className="fade-in" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '60px 24px', textAlign: 'center' }}>
      <div style={{
        width: 64, height: 64, borderRadius: 16, background: 'var(--accent-dim)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 20,
      }}>
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="var(--accent)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
      </div>
      <div style={{ fontSize: 17, fontWeight: 800, color: 'var(--text-primary)', marginBottom: 8 }}>{title}</div>
      <div style={{ fontSize: 13, color: 'var(--text-secondary)', maxWidth: 400, lineHeight: 1.6, marginBottom: 16 }}>
        {description || 'This section is under development and will be available in a future phase.'}
      </div>
      <span style={{
        fontSize: 11.5, fontWeight: 700, background: 'var(--accent-dim)', color: 'var(--accent)',
        borderRadius: 999, padding: '4px 12px',
      }}>
        Coming in {phase}
      </span>
    </div>
  );
}

// ─── MAIN PAGE ───────────────────────────────────────────────────────────────

export default function UserAccessControl({ toast, user, onBack }) {
  const { section } = useParams();
  const navigate = useNavigate();
  const active = section || 'dashboard';
  const setActive = (id) => navigate(`/admin/user-access/${id}`, { replace: false });

  const renderContent = () => {
    switch (active) {
      case 'dashboard': return <AccessDashboard />;
      case 'users': return <UserMaster toast={toast} />;
      case 'roles': return <RoleMaster toast={toast} />;
      case 'permissions': return (
        <PermissionMatrix toast={toast} />
      );
      case 'branches': return <OrgHierarchy toast={toast} />;
      case 'approval_limits': return <ApprovalLimits toast={toast} />;
      case 'modification_access': return <ModificationAccessControl toast={toast} />;
      case 'year_access': return <YearAccessControl toast={toast} />;
      case 'access_requests': return <AccessRequestCenter toast={toast} user={user} />;
      case 'audit_trail': return <PermissionAuditTrail toast={toast} />;
      case 'access_reports': return <AccessReportCenter toast={toast} />;
      default: return <AccessDashboard />;
    }
  };

  const activeLabel = (() => {
    for (const group of NAV) {
      const item = group.items.find(i => i.id === active);
      if (item) return item.label;
    }
    return '';
  })();

  return (
    <div style={{ display: 'flex', height: '100%', minHeight: 0 }}>
      {/* Left Sidebar */}
      <div style={{
        width: 250, flexShrink: 0, border: '1px solid #000', borderRadius: 14,
        background: 'var(--bg-surface)', overflowY: 'auto',
        display: 'flex', flexDirection: 'column',
      }}>
        {/* Header */}
        <div style={{ padding: '20px 16px 14px', borderBottom: '1px solid var(--border-light)' }}>
          <div style={{ fontSize: 13, fontWeight: 800, color: 'var(--text-primary)', marginBottom: 3 }}>User Access &</div>
          <div style={{ fontSize: 13, fontWeight: 800, color: 'var(--text-primary)', marginBottom: 6 }}>Authorization Center</div>
          <div style={{ fontSize: 11, color: 'var(--text-muted)', lineHeight: 1.4 }}>
            Enterprise-grade access management — roles, permissions, sites, companies, years, modifications &amp; audit
          </div>
        </div>

        {/* Nav */}
        <nav style={{ padding: '12px 0', flex: 1 }}>
          {NAV.map(group => (
            <div key={group.group} style={{ marginBottom: 4 }}>
              <div style={{ padding: '6px 16px 4px', fontSize: 10, fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.07em' }}>
                {group.group}
              </div>
              {group.items.map(item => {
                const Icon = item.icon;
                const isActive = active === item.id;
                const isDisabled = !!item.badge;
                return (
                  <button
                    key={item.id}
                    onClick={() => setActive(item.id)}
                    style={{
                      display: 'flex', alignItems: 'center', gap: 9, width: '100%',
                      padding: '8px 14px 8px 16px', border: 'none', cursor: isDisabled ? 'default' : 'pointer',
                      background: isActive ? 'var(--accent-dim)' : 'none',
                      color: isActive ? 'var(--accent)' : isDisabled ? 'var(--text-muted)' : 'var(--text-primary)',
                      fontWeight: isActive ? 700 : 500, fontSize: 12.5, fontFamily: 'var(--font)',
                      textAlign: 'left', borderRadius: '0 999px 999px 0', marginRight: 8,
                      opacity: isDisabled ? 0.6 : 1,
                      transition: 'background 0.12s, color 0.12s',
                    }}
                    onMouseEnter={e => { if (!isActive && !isDisabled) e.currentTarget.style.background = 'var(--bg-hover)'; }}
                    onMouseLeave={e => { if (!isActive) e.currentTarget.style.background = 'none'; }}
                  >
                    <span style={{ flexShrink: 0, display: 'flex', alignItems: 'center' }}><Icon /></span>
                    <span style={{ flex: 1, lineHeight: 1.3 }}>{item.label}</span>
                    {item.badge && (
                      <span style={{ fontSize: 9.5, fontWeight: 700, background: 'var(--bg-elevated)', color: 'var(--text-muted)', borderRadius: 999, padding: '1px 5px', flexShrink: 0 }}>
                        {item.badge}
                      </span>
                    )}
                    {isActive && <span style={{ width: 4, height: 4, borderRadius: 999, background: 'var(--accent)', flexShrink: 0 }} />}
                  </button>
                );
              })}
            </div>
          ))}
        </nav>
      </div>

      {/* Main content */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '24px 28px', minWidth: 0 }}>
        {renderContent()}
      </div>
    </div>
  );
}
